<div class="cartera-root">
  <!-- Loading overlay global inicial -->
  <div class="ct-loading-overlay" *ngIf="!initialLoaded">
    <div class="ct-loading-card">
      <div class="ct-loading-spinner"></div>
      <div class="ct-loading-text">Cargando Centro de Operaciones</div>
      <div class="ct-loading-sub">Calculando KPIs sobre 1.87M de clientes...</div>
    </div>
  </div>

  <!-- Header minimalista -->
  <header class="ct-header">
    <div>
      <h1>Cartera y Mora</h1>
      <p class="ct-subtitle" *ngIf="kpis">
        {{ fmtInt(kpis.total_clientes) }} clientes · actualización {{ fmtRelative(kpis.freshness.last_recalc_max) }}
        <span *ngIf="loadingKpis" class="ct-dot"></span>
      </p>
    </div>
    <button class="ct-btn-ghost" (click)="loadKPIs()" [disabled]="loadingKpis">
      {{ loadingKpis ? 'Cargando...' : 'Refrescar' }}
    </button>
  </header>

  <!-- Tabs -->
  <nav class="ct-tabs">
    <button class="ct-tab" [class.active]="activeTab === 'resumen'" (click)="setTab('resumen')">
      Resumen
    </button>
    <button class="ct-tab" [class.active]="activeTab === 'clientes'" (click)="setTab('clientes')">
      Clientes
    </button>
    <button class="ct-tab" [class.active]="activeTab === 'analisis'" (click)="setTab('analisis')">
      Análisis
    </button>
    <button class="ct-tab" [class.active]="activeTab === 'operacion'" (click)="setTab('operacion')">
      Operación
    </button>
    <button class="ct-tab" [class.active]="activeTab === 'procesos'" (click)="setTab('procesos')">
      Procesos
    </button>
    <button class="ct-tab" [class.active]="activeTab === 'morosidad'" (click)="setTab('morosidad')">
      Morosidad
    </button>
    <button class="ct-tab" [class.active]="activeTab === 'comportamiento'" (click)="setTab('comportamiento')">
      Comportamiento
    </button>
    <button class="ct-tab" [class.active]="activeTab === 'gestion-cobro'" (click)="setTab('gestion-cobro')">
      💰 Gestión de Cobro
    </button>
    <button class="ct-tab" [class.active]="activeTab === 'anomalias'" (click)="setTab('anomalias')">
      🔍 Anomalías
    </button>
  </nav>

  <!-- ─── TAB: RESUMEN ─────────────────────────────────── -->
  <section *ngIf="activeTab === 'resumen'" class="ct-tab-panel">

    <ng-container *ngIf="kpis">
      <!-- ━━━ UNIVERSO DE CLIENTES ━━━ -->
      <h2 class="ct-section-title">👥 Universo de clientes</h2>
      <div class="ct-kpis">
        <div class="ct-kpi">
          <div class="ct-kpi-label">Total clientes</div>
          <div class="ct-kpi-value">{{ fmtInt(kpis.total_clientes) }}</div>
          <div class="ct-kpi-sub">{{ fmtInt(kpis.con_mora_field) }} con historial</div>
        </div>
        <div class="ct-kpi">
          <div class="ct-kpi-label">En mora</div>
          <div class="ct-kpi-value">{{ fmtInt(kpis.en_mora_count) }}</div>
          <div class="ct-kpi-sub">{{ fmtPct(kpis.en_mora_pct) }} del total</div>
        </div>
        <div class="ct-kpi">
          <div class="ct-kpi-label">Bloqueados</div>
          <div class="ct-kpi-value">{{ fmtInt(kpis.estado.bloqueados_total) }}</div>
          <div class="ct-kpi-sub">{{ fmtInt(kpis.estado.bloqueo_manual) }} manuales</div>
        </div>
        <div class="ct-kpi">
          <div class="ct-kpi-label">Reactivados</div>
          <div class="ct-kpi-value">{{ fmtInt(kpis.estado.reactivados_alguna_vez) }}</div>
          <div class="ct-kpi-sub">Pagaron C004 alguna vez</div>
        </div>
      </div>

      <!-- ━━━ DEUDA ACTUAL ━━━ -->
      <h2 class="ct-section-title">💰 Deuda actual</h2>
      <div class="ct-kpis">
        <div class="ct-kpi ct-kpi-accent">
          <div class="ct-kpi-label">$ Cuotas en mora</div>
          <div class="ct-kpi-value">{{ fmtMoney(kpis.monto_cuotas_en_mora) }}</div>
          <div class="ct-kpi-sub">Capital vencido (sin fees)</div>
        </div>
        <div class="ct-kpi ct-kpi-accent">
          <div class="ct-kpi-label">$ Adeudado en fees</div>
          <div class="ct-kpi-value">{{ fmtMoney(kpis.monto_fees_pendientes) }}</div>
          <div class="ct-kpi-sub">{{ fmtInt(kpis.fees.c001_pendientes_count + kpis.fees.c004_pendientes_count) }} fees pendientes</div>
        </div>
        <div class="ct-kpi ct-kpi-accent">
          <div class="ct-kpi-label">$ Deuda total</div>
          <div class="ct-kpi-value">{{ fmtMoney(kpis.deuda_total) }}</div>
          <div class="ct-kpi-sub">Cuotas + fees pendientes</div>
        </div>
        <div class="ct-kpi">
          <div class="ct-kpi-label">Promedio por cliente</div>
          <div class="ct-kpi-value">{{ fmtMoney(kpis.en_mora_count > 0 ? (kpis.deuda_total / kpis.en_mora_count) : 0) }}</div>
          <div class="ct-kpi-sub">Deuda total / clientes en mora</div>
        </div>
      </div>

      <!-- ━━━ FEES PENDIENTES (por cobrar) ━━━ -->
      <h2 class="ct-section-title">📋 Fees pendientes — por concepto</h2>
      <div class="ct-kpis">
        <div class="ct-kpi">
          <div class="ct-kpi-label">Fees C001 pendientes</div>
          <div class="ct-kpi-value">{{ fmtInt(kpis.fees.c001_pendientes_count) }}</div>
          <div class="ct-kpi-sub">{{ fmtMoney(kpis.fees.c001_pendientes_monto) }}</div>
        </div>
        <div class="ct-kpi">
          <div class="ct-kpi-label">Fees C004 pendientes</div>
          <div class="ct-kpi-value">{{ fmtInt(kpis.fees.c004_pendientes_count) }}</div>
          <div class="ct-kpi-sub">{{ fmtMoney(kpis.fees.c004_pendientes_monto) }}</div>
        </div>
      </div>

      <!-- ━━━ RECAUDACIÓN HISTÓRICA ━━━ -->
      <h2 class="ct-section-title">📈 Recaudación histórica</h2>
      <div class="ct-kpis">
        <div class="ct-kpi">
          <div class="ct-kpi-label">Fees pagados lifetime</div>
          <div class="ct-kpi-value">{{ fmtInt(kpis.fees.pagados_lifetime_count) }}</div>
          <div class="ct-kpi-sub">{{ fmtMoney(kpis.fees.pagados_lifetime_monto) }} recaudados</div>
        </div>
        <div class="ct-kpi">
          <div class="ct-kpi-label">Tasa de cobro fees</div>
          <div class="ct-kpi-value">{{ fmtPct((kpis.fees.pagados_lifetime_count / (kpis.fees.pagados_lifetime_count + kpis.fees.c001_pendientes_count + kpis.fees.c004_pendientes_count)) * 100) }}</div>
          <div class="ct-kpi-sub">Pagados / (pagados + pendientes)</div>
        </div>
      </div>

      <!-- Charts en grid 2x2 -->
      <div class="ct-charts-grid">
        <div class="ct-card ct-chart-card">
          <h3>Distribución por bucket</h3>
          <div class="ct-chart-canvas">
            <canvas #bucketChart></canvas>
          </div>
        </div>

        <div class="ct-card ct-chart-card">
          <h3>Estado de clientes</h3>
          <div class="ct-chart-canvas">
            <canvas #estadoChart></canvas>
          </div>
        </div>

        <div class="ct-card ct-chart-card ct-chart-wide">
          <h3>Fees C001 vs C004 vs pagados</h3>
          <div class="ct-chart-canvas">
            <canvas #feesChart></canvas>
          </div>
        </div>

        <div class="ct-card ct-chart-card ct-chart-wide">
          <h3>Distribución fina de mora</h3>
          <div class="ct-chart-canvas">
            <canvas #distChart></canvas>
          </div>
        </div>
      </div>

      <!-- ESCALAFÓN DE FEES — por concepto + monto del fee -->
      <div class="ct-card" *ngIf="escalafon">
        <h3>Escalafón de fees (pendientes)</h3>
        <div class="ct-analisis-desc" style="margin: 8px 0 12px;">
          <strong>{{ fmtInt(escalafon.total_fees) }}</strong> fees pendientes por <strong>{{ fmtMoney(escalafon.total_monto) }}</strong> totales.
          Desglose por concepto y monto del fee.
        </div>
        <table class="ct-table">
          <thead>
            <tr><th>Concepto</th><th>Monto fee</th><th># Fees</th><th>Monto total</th><th>Saldo pendiente</th><th>Clientes únicos</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let b of escalafon.breakdown">
              <td><span class="ct-fee-tag">{{ b.concepto }}</span></td>
              <td class="ct-money">{{ fmtMoney(b.monto_fee) }}</td>
              <td>{{ fmtInt(b.count) }}</td>
              <td class="ct-money">{{ fmtMoney(b.monto_total) }}</td>
              <td class="ct-money">{{ fmtMoney(b.due_balance_total) }}</td>
              <td>{{ fmtInt(b.clientes_unicos) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Tabla de buckets debajo de los charts -->
      <div class="ct-card">
        <h3>Detalle por bucket</h3>
        <div class="ct-bucket-bars">
          <div class="ct-bucket" *ngFor="let item of (kpis.buckets | keyvalue)">
            <div class="ct-bucket-label">{{ item.key }}</div>
            <div class="ct-bucket-track">
              <div class="ct-bucket-fill" [style.width.%]="bucketPct(item.value.count)">
                <span class="ct-bucket-count">{{ fmtInt(item.value.count) }}</span>
              </div>
            </div>
            <div class="ct-bucket-monto">{{ fmtMoney(item.value.monto) }}</div>
          </div>
        </div>
      </div>

      <!-- Estado de Person.mora freshness — solo si pasó más de 24h del último recalc -->
      <div class="ct-card ct-card-info" *ngIf="kpis.freshness.stale_minutes && kpis.freshness.stale_minutes > 1440">
        <strong>Datos parciales:</strong> algunos clientes tienen mora calculada hace más de 24 horas
        ({{ (kpis.freshness.stale_minutes / 60) | number: '1.0-0' }} h).
        Disparar el job <code>person_mora_backfill</code> desde la pestaña Procesos para refrescar.
      </div>
    </ng-container>
  </section>

  <!-- ─── TAB: CLIENTES ─────────────────────────────────── -->
  <section *ngIf="activeTab === 'clientes'" class="ct-tab-panel">

    <!-- Quick filters chips -->
    <div class="ct-quick-filters">
      <button class="ct-chip" [class.active]="activeQuickFilter === 'criticos'" (click)="applyQuickFilter('criticos')">
        🔴 Críticos (&gt;90d)
      </button>
      <button class="ct-chip" [class.active]="activeQuickFilter === 'cerca_c004'" (click)="applyQuickFilter('cerca_c004')">
        🟡 Cerca C004 (50-65d)
      </button>
      <button class="ct-chip" [class.active]="activeQuickFilter === 'fees_c001'" (click)="applyQuickFilter('fees_c001')">
        💰 Aplican C001 (4-65d)
      </button>
      <button class="ct-chip" [class.active]="activeQuickFilter === 'fees_c004'" (click)="applyQuickFilter('fees_c004')">
        ⚠️ Aplican C004 (61-90d)
      </button>
      <button class="ct-chip" [class.active]="activeQuickFilter === 'recien'" (click)="applyQuickFilter('recien')">
        🟢 Recién entraron (1-3d)
      </button>
      <button class="ct-chip" [class.active]="activeQuickFilter === 'reactivados'" (click)="applyQuickFilter('reactivados')">
        ♻️ Con reactivación
      </button>
      <button class="ct-chip" [class.active]="activeQuickFilter === 'bloqueados_auto'" (click)="applyQuickFilter('bloqueados_auto')">
        🚫 Bloqueo automático
      </button>
    </div>

    <!-- Filtros -->
    <div class="ct-card ct-filters">
      <div class="ct-filter-row">
        <input type="text" class="ct-input ct-input-search"
               placeholder="Buscar por cédula, código o nombre..."
               [(ngModel)]="filters.search"
               (input)="onSearchChange()">

        <div class="ct-filter-grp">
          <label>Mora</label>
          <input type="number" placeholder="min" [ngModel]="filters.dias_min" (ngModelChange)="onMoraMinChange($event)" class="ct-input ct-input-num">
          <span>–</span>
          <input type="number" placeholder="max" [ngModel]="filters.dias_max" (ngModelChange)="onMoraMaxChange($event)" class="ct-input ct-input-num">
        </div>

        <div class="ct-filter-grp">
          <label>Estado</label>
          <select [(ngModel)]="filters.estado" class="ct-input">
            <option value="">—</option>
            <option value="activo">Activo</option>
            <option value="bloqueado">Bloqueado</option>
          </select>
        </div>

        <div class="ct-filter-grp">
          <label>Bloqueo</label>
          <select [(ngModel)]="filters.bloqueo_tipo" class="ct-input">
            <option value="">—</option>
            <option value="manual">Manual</option>
            <option value="automatico">Automático</option>
            <option value="reactivacion">Reactivación</option>
          </select>
        </div>

        <div class="ct-filter-grp">
          <label>Reactiv.</label>
          <select [(ngModel)]="filters.tiene_reactivaciones" class="ct-input">
            <option value="">—</option>
            <option value="true">Con</option>
            <option value="false">Sin</option>
          </select>
        </div>

        <button class="ct-btn-primary" (click)="applyFilters()">Aplicar</button>
        <button class="ct-btn-ghost" (click)="resetFilters()">Limpiar</button>
      </div>
    </div>

    <!-- Toolbar -->
    <div class="ct-toolbar">
      <span class="ct-count">
        <strong>{{ fmtInt(total) }}</strong> clientes
        <span *ngIf="loadingClientes" class="ct-dot">actualizando</span>
      </span>
      <div class="ct-toolbar-actions">
        <button class="ct-btn-ghost ct-btn-mini" (click)="exportFiltrado()" [disabled]="clientes.length === 0">
          📥 Exportar página
        </button>
        <div class="ct-page-size">
          <label>Mostrar:</label>
          <select [(ngModel)]="pageSize" (change)="loadClientes()" class="ct-input">
            <option [ngValue]="25">25</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
            <option [ngValue]="250">250</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Bulk action bar (visible solo si hay selección) -->
    <div class="ct-bulk-bar" *ngIf="selectedIds.size > 0">
      <span class="ct-bulk-count"><strong>{{ selectedIds.size }}</strong> seleccionados</span>
      <button class="ct-btn-primary ct-btn-mini" (click)="bulkRecalc()" [disabled]="bulkActionLoading === 'recalc'">
        <span *ngIf="bulkActionLoading === 'recalc'" class="ct-spinner-sm"></span>
        ↻ Recalcular mora
      </button>
      <button class="ct-btn-ghost ct-btn-mini" (click)="exportSeleccion()">📥 Exportar CSV</button>
      <button class="ct-btn-ghost ct-btn-mini" (click)="clearSelection()">✕ Limpiar</button>
      <span *ngIf="bulkMessage" class="ct-bulk-msg">{{ bulkMessage }}</span>
    </div>

    <!-- Loader inicial -->
    <div *ngIf="!clientesEverLoaded && loadingClientes" class="ct-empty">
      <span class="ct-spinner-sm"></span> Cargando clientes...
    </div>

    <!-- Tabla -->
    <div class="ct-card ct-no-padding" *ngIf="clientesEverLoaded">
      <div class="ct-table-wrap">
        <table class="ct-table">
          <thead>
            <tr>
              <th class="ct-check-col">
                <input type="checkbox" [checked]="allPageSelected()" (change)="toggleSelectAll($any($event.target).checked)">
              </th>
              <th (click)="setSort('code')" class="ct-sortable">Cliente</th>
              <th>Cédula</th>
              <th (click)="setSort('mora.actual')" class="ct-sortable">Días mora</th>
              <th>Cuotas</th>
              <th (click)="setSort('mora.actual_monto_pendiente')" class="ct-sortable">$ Adeudado</th>
              <th>Fees C001</th>
              <th>Fees C004</th>
              <th>Reactiv.</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of clientes" (click)="openCliente(c)" class="ct-row" [class.selected]="isSelected(c.id)">
              <td class="ct-check-col" (click)="$event.stopPropagation()">
                <input type="checkbox" [checked]="isSelected(c.id)" (change)="toggleSelect(c.id)">
              </td>
              <td>
                <div class="ct-cliente-name">{{ c.full_name || '—' }}</div>
                <div class="ct-cliente-code">{{ c.identity || '—' }}</div>
              </td>
              <td>{{ c.identity || '—' }}</td>
              <td>
                <span class="ct-mora-badge" [ngClass]="moraBadge(c.mora_dias)">{{ c.mora_dias }}d</span>
              </td>
              <td class="ct-center">{{ c.mora_count }}</td>
              <td class="ct-money">{{ fmtMoney(c.monto_adeudado) }}</td>
              <td>
                <span *ngIf="c.fees_c001_pend_count > 0" class="ct-fee-pill">
                  {{ c.fees_c001_pend_count }} · {{ fmtMoney(c.fees_c001_pend_monto) }}
                </span>
                <span *ngIf="c.fees_c001_pend_count === 0" class="ct-muted">—</span>
              </td>
              <td>
                <span *ngIf="c.fees_c004_pend_count > 0" class="ct-fee-pill">
                  {{ c.fees_c004_pend_count }} · {{ fmtMoney(c.fees_c004_pend_monto) }}
                </span>
                <span *ngIf="c.fees_c004_pend_count === 0" class="ct-muted">—</span>
              </td>
              <td class="ct-center">
                <span *ngIf="c.penalty_reactivation_count > 0" class="ct-reactivation-pill">
                  {{ c.penalty_reactivation_count }}×
                </span>
                <span *ngIf="c.penalty_reactivation_count === 0" class="ct-muted">—</span>
              </td>
              <td>
                <span *ngIf="c.quota_active" class="ct-status active">Activo</span>
                <span *ngIf="!c.quota_active" class="ct-status blocked">
                  {{ c.user_blocked_manually ? 'Manual' : 'Auto' }}
                </span>
              </td>
            </tr>
            <tr *ngIf="clientes.length === 0 && !loadingClientes">
              <td colspan="10" class="ct-empty-row">Sin resultados con estos filtros</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Paginación -->
    <div class="ct-pagination" *ngIf="clientesEverLoaded && totalPages > 1">
      <button (click)="prevPage()" [disabled]="page <= 1" class="ct-btn-ghost">‹ Anterior</button>
      <span>Página {{ page }} de {{ fmtInt(totalPages) }}</span>
      <button (click)="nextPage()" [disabled]="page >= totalPages" class="ct-btn-ghost">Siguiente ›</button>
    </div>
  </section>

  <!-- ─── TAB: PROCESOS ─────────────────────────────────── -->
  <section *ngIf="activeTab === 'procesos'" class="ct-tab-panel">
    <div class="ct-grid-2">
      <!-- Acciones masivas -->
      <div class="ct-card">
        <h3>Acciones masivas</h3>
        <div class="ct-job-list">
          <button *ngFor="let job of jobs"
                  class="ct-job-btn"
                  (click)="triggerJob(job.job_key)"
                  [disabled]="triggering === job.job_key">
            <div class="ct-job-label">{{ job.label || job.job_key }}</div>
            <div class="ct-job-meta">
              <span class="ct-job-key">{{ job.job_key }}</span>
              <span class="ct-job-action">
                {{ triggering === job.job_key ? '⟳ disparando...' : '▸ Correr' }}
              </span>
            </div>
          </button>
          <div *ngIf="jobs.length === 0" class="ct-muted ct-center">Sin jobs registrados</div>
        </div>
      </div>

      <!-- Actividad reciente -->
      <div class="ct-card">
        <h3>Actividad reciente</h3>
        <ul class="ct-activity">
          <li *ngFor="let r of recentRuns" (click)="goToRun(r._id)" class="ct-activity-item">
            <div class="ct-activity-head">
              <span class="ct-job-key">{{ r.job_key }}</span>
              <span class="ct-status-pill" [ngClass]="statusBadge(r.status)">{{ r.status }}</span>
            </div>
            <div class="ct-activity-meta">
              <span>{{ fmtRelative(r.started_at) }}</span>
              <span *ngIf="r.progress?.processed != null">
                · {{ fmtInt(r.progress?.processed) }}<span *ngIf="r.progress?.total"> / {{ fmtInt(r.progress?.total) }}</span>
              </span>
            </div>
          </li>
          <li *ngIf="recentRuns.length === 0" class="ct-empty-row">Sin actividad reciente</li>
        </ul>
      </div>
    </div>
  </section>

  <!-- ─── TAB: ANÁLISIS ─────────────────────────────────── -->
  <section *ngIf="activeTab === 'analisis'" class="ct-tab-panel">

    <!-- Sub-tabs de análisis -->
    <div class="ct-subtabs">
      <button class="ct-subtab" [class.active]="analisisTab === 'top'" (click)="setAnalisisTab('top')">Top Críticos</button>
      <button class="ct-subtab" [class.active]="analisisTab === 'vintage'" (click)="setAnalisisTab('vintage')">Vintage</button>
      <button class="ct-subtab" [class.active]="analisisTab === 'roll'" (click)="setAnalisisTab('roll')">Roll Rate</button>
      <button class="ct-subtab" [class.active]="analisisTab === 'cure'" (click)="setAnalisisTab('cure')">Cure Rate</button>
      <button class="ct-subtab" [class.active]="analisisTab === 'ecl'" (click)="setAnalisisTab('ecl')">ECL · NIIF 9</button>
      <button class="ct-subtab" [class.active]="analisisTab === 'aliado'" (click)="setAnalisisTab('aliado')">Por Aliado</button>
      <button class="ct-subtab" [class.active]="analisisTab === 'prediccion'" (click)="setAnalisisTab('prediccion')">Predicción 30/60/90</button>
      <button class="ct-subtab" [class.active]="analisisTab === 'reactivaciones'" (click)="setAnalisisTab('reactivaciones')">Reactivaciones</button>

      <span class="ct-subtab-spacer"></span>
      <button class="ct-btn-ghost ct-btn-mini" (click)="refreshAnalisisCache()">⟳ Refrescar</button>
    </div>

    <!-- Descripción contextual de cada vista -->
    <div class="ct-analisis-desc">
      <ng-container [ngSwitch]="analisisTab">
        <span *ngSwitchCase="'top'"><strong>Top 100 clientes más críticos</strong> — ranking por días de mora, monto pendiente y comportamiento histórico</span>
        <span *ngSwitchCase="'vintage'"><strong>Cohort retention</strong> — clientes por mes de originación vs % en mora hoy. Identifica vintages problemáticos</span>
        <span *ngSwitchCase="'roll'"><strong>Roll Rate matrix</strong> — % de clientes que transitan de un bucket de mora al siguiente en N días</span>
        <span *ngSwitchCase="'cure'"><strong>Cure Rate</strong> — % de clientes que sale de mora por bucket. Mide eficacia de cobranza</span>
        <span *ngSwitchCase="'ecl'"><strong>ECL · NIIF 9</strong> — provisión esperada por stages 1 (al día), 2 (1-90d) y 3 (default >90d)</span>
        <span *ngSwitchCase="'aliado'"><strong>Por Aliado / Canal</strong> — desempeño de cartera segmentado por canal de originación</span>
        <span *ngSwitchCase="'prediccion'"><strong>Predicción 30/60/90</strong> — clientes que entrarán a cada bucket si no pagan en los próximos días</span>
        <span *ngSwitchCase="'reactivaciones'"><strong>Reactivaciones C004</strong> — historial completo de pagos C004 y análisis de recurrencia</span>
      </ng-container>
    </div>

    <!-- Loading -->
    <div *ngIf="analisisLoading[analisisTab]" class="ct-empty">
      <span class="ct-spinner-sm"></span> Calculando análisis…
    </div>

    <!-- Error -->
    <div *ngIf="analisisError[analisisTab]" class="ct-card ct-card-info">
      Error: {{ analisisError[analisisTab] }}
    </div>

    <!-- Data table dinámica -->
    <div class="ct-card ct-no-padding"
         *ngIf="!analisisLoading[analisisTab] && analisisData[analisisTab] && analisisData[analisisTab]!.length > 0">
      <div class="ct-analisis-toolbar">
        <span>{{ analisisData[analisisTab]!.length }} filas</span>
      </div>
      <div class="ct-table-wrap">
        <table class="ct-table">
          <thead>
            <tr>
              <th *ngFor="let col of getColumns(analisisData[analisisTab])">{{ col }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of analisisData[analisisTab]">
              <td *ngFor="let col of getColumns(analisisData[analisisTab])">
                {{ formatCell(row[col]) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="!analisisLoading[analisisTab] && analisisData[analisisTab] && analisisData[analisisTab]!.length === 0" class="ct-empty">
      Sin datos disponibles para esta vista
    </div>
  </section>

  <!-- ─── TAB: OPERACIÓN ────────────────────────────────── -->
  <section *ngIf="activeTab === 'operacion'" class="ct-tab-panel">
    <div class="ct-subtabs">
      <button class="ct-subtab" [class.active]="operacionTab === 'movimientos'" (click)="setOperacionTab('movimientos')">Movimientos</button>
      <button class="ct-subtab" [class.active]="operacionTab === 'recaudacion'" (click)="setOperacionTab('recaudacion')">Recaudación</button>
      <button class="ct-subtab" [class.active]="operacionTab === 'proximos_c004'" (click)="setOperacionTab('proximos_c004')">Próximos a C004</button>
      <button class="ct-subtab" [class.active]="operacionTab === 'aging'" (click)="setOperacionTab('aging')">Aging contable</button>
    </div>

    <!-- ─── Movimientos hoy ─── -->
    <ng-container *ngIf="operacionTab === 'movimientos'">
      <div class="ct-analisis-desc">
        <strong>Movimientos en el rango</strong> — fees C001/C004 creados, actualizados o desactivados en el período seleccionado.
      </div>

      <!-- Date filter chips -->
      <div class="ct-date-bar">
        <button class="ct-chip" [class.active]="movPreset==='hoy'"        (click)="setMovPreset('hoy')">Hoy</button>
        <button class="ct-chip" [class.active]="movPreset==='ayer'"       (click)="setMovPreset('ayer')">Ayer</button>
        <button class="ct-chip" [class.active]="movPreset==='esta_semana'"(click)="setMovPreset('esta_semana')">Esta semana</button>
        <button class="ct-chip" [class.active]="movPreset==='este_mes'"   (click)="setMovPreset('este_mes')">Este mes</button>
        <button class="ct-chip" [class.active]="movPreset==='mes_pasado'" (click)="setMovPreset('mes_pasado')">Mes pasado</button>
        <button class="ct-chip" [class.active]="movPreset==='lifetime'"   (click)="setMovPreset('lifetime')">Todo</button>
        <span class="ct-divisor">|</span>
        <label>Rango:</label>
        <input type="date" class="ct-input" [(ngModel)]="movFrom">
        <span>—</span>
        <input type="date" class="ct-input" [(ngModel)]="movTo">
        <button class="ct-btn-primary ct-btn-mini" (click)="applyMovCustom()">Aplicar</button>
      </div>

      <div *ngIf="loadingMov" class="ct-empty"><span class="ct-spinner-sm"></span> Cargando movimientos…</div>

      <ng-container *ngIf="movimientos && !loadingMov">
        <!-- Resumen del día -->
        <div class="ct-kpis">
          <div class="ct-kpi">
            <div class="ct-kpi-label">Creados hoy</div>
            <div class="ct-kpi-value">{{ fmtInt(movimientos.resumen.creados_hoy) }}</div>
            <div class="ct-kpi-sub">{{ movimientos.resumen.c001_creados }} C001 · {{ movimientos.resumen.c004_creados }} C004</div>
          </div>
          <div class="ct-kpi">
            <div class="ct-kpi-label">Actualizados</div>
            <div class="ct-kpi-value">{{ fmtInt(movimientos.resumen.actualizados_hoy) }}</div>
            <div class="ct-kpi-sub">Cambio de días o rango</div>
          </div>
          <div class="ct-kpi">
            <div class="ct-kpi-label">Desactivados</div>
            <div class="ct-kpi-value">{{ fmtInt(movimientos.resumen.desactivados_hoy) }}</div>
            <div class="ct-kpi-sub">Salieron de mora o fee obsoleto</div>
          </div>
        </div>

        <!-- Tabla creados -->
        <div class="ct-card ct-no-padding" *ngIf="movimientos.creados && movimientos.creados.length > 0">
          <div class="ct-analisis-toolbar">Fees creados hoy ({{ movimientos.creados.length }} más recientes)</div>
          <div class="ct-table-wrap">
            <table class="ct-table">
              <thead>
                <tr><th>Concepto</th><th>Cliente</th><th>Cédula/Código</th><th>Días</th><th>Monto</th><th>Creado</th></tr>
              </thead>
              <tbody>
                <tr *ngFor="let m of movimientos.creados">
                  <td><span class="ct-fee-tag">{{ m.concept }}</span></td>
                  <td>{{ m.name }} {{ m.lastName }}</td>
                  <td class="ct-mono">{{ m.code }}</td>
                  <td><span class="ct-mora-badge" [ngClass]="moraBadge(m.days)">{{ m.days }}d</span></td>
                  <td class="ct-money">{{ fmtMoney(m.amount) }}</td>
                  <td>{{ fmtRelative(m.date) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="ct-card ct-no-padding" *ngIf="movimientos.desactivados && movimientos.desactivados.length > 0">
          <div class="ct-analisis-toolbar">Fees desactivados hoy ({{ movimientos.desactivados.length }})</div>
          <div class="ct-table-wrap">
            <table class="ct-table">
              <thead><tr><th>Concepto</th><th>Cliente</th><th>Motivo</th><th>Días originales</th><th>Desactivado</th></tr></thead>
              <tbody>
                <tr *ngFor="let m of movimientos.desactivados">
                  <td><span class="ct-fee-tag">{{ m.concept }}</span></td>
                  <td>{{ m.name }} {{ m.lastName }} <span class="ct-cliente-code">{{ m.code }}</span></td>
                  <td class="ct-mono">{{ m.message || '—' }}</td>
                  <td>{{ m.days }}d</td>
                  <td>{{ fmtRelative(m.deleted_at) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div *ngIf="(!movimientos.creados || movimientos.creados.length === 0) && (!movimientos.desactivados || movimientos.desactivados.length === 0)" class="ct-empty">
          Sin movimientos registrados hoy
        </div>
      </ng-container>
    </ng-container>

    <!-- ─── Recaudación ─── -->
    <ng-container *ngIf="operacionTab === 'recaudacion'">
      <div class="ct-analisis-desc">
        <strong>Recaudación por concepto</strong> — fees y penalidades cobrados en el período (status = Pago Completado).
        Desglose por C001/C002/C003/C004 + top clientes que más pagaron.
      </div>

      <div class="ct-date-bar">
        <button class="ct-chip" [class.active]="recPreset==='hoy'"        (click)="setRecPreset('hoy')">Hoy</button>
        <button class="ct-chip" [class.active]="recPreset==='ayer'"       (click)="setRecPreset('ayer')">Ayer</button>
        <button class="ct-chip" [class.active]="recPreset==='esta_semana'"(click)="setRecPreset('esta_semana')">Esta semana</button>
        <button class="ct-chip" [class.active]="recPreset==='este_mes'"   (click)="setRecPreset('este_mes')">Este mes</button>
        <button class="ct-chip" [class.active]="recPreset==='mes_pasado'" (click)="setRecPreset('mes_pasado')">Mes pasado</button>
        <button class="ct-chip" [class.active]="recPreset==='lifetime'"   (click)="setRecPreset('lifetime')">Todo</button>
        <span class="ct-divisor">|</span>
        <label>Rango:</label>
        <input type="date" class="ct-input" [(ngModel)]="recFrom">
        <span>—</span>
        <input type="date" class="ct-input" [(ngModel)]="recTo">
        <button class="ct-btn-primary ct-btn-mini" (click)="applyRecCustom()">Aplicar</button>
      </div>

      <div *ngIf="loadingRecaudacion" class="ct-empty"><span class="ct-spinner-sm"></span> Calculando recaudación…</div>

      <ng-container *ngIf="recaudacion && !loadingRecaudacion">
        <!-- KPIs de recaudación -->
        <div class="ct-kpis">
          <div class="ct-kpi ct-kpi-accent">
            <div class="ct-kpi-label">Total recaudado</div>
            <div class="ct-kpi-value">{{ fmtMoney(recaudacion.total_monto) }}</div>
            <div class="ct-kpi-sub">{{ fmtInt(recaudacion.total_count) }} pagos</div>
          </div>
          <div class="ct-kpi" *ngFor="let c of recaudacion.por_concepto">
            <div class="ct-kpi-label">{{ c.concepto }}</div>
            <div class="ct-kpi-value">{{ fmtMoney(c.monto) }}</div>
            <div class="ct-kpi-sub">{{ fmtInt(c.count) }} pagos · {{ fmtInt(c.clientes_unicos) }} clientes</div>
          </div>
        </div>

        <!-- Tabla por concepto -->
        <div class="ct-card ct-no-padding">
          <div class="ct-analisis-toolbar">Desglose por concepto</div>
          <div class="ct-table-wrap">
            <table class="ct-table">
              <thead><tr><th>Concepto</th><th>Descripción</th><th>Pagos</th><th>Monto recaudado</th><th>Clientes únicos</th><th>Promedio/pago</th></tr></thead>
              <tbody>
                <tr *ngFor="let c of recaudacion.por_concepto">
                  <td><span class="ct-fee-tag">{{ c.concepto }}</span></td>
                  <td>{{ c.concepto_nombre || '—' }}</td>
                  <td>{{ fmtInt(c.count) }}</td>
                  <td class="ct-money">{{ fmtMoney(c.monto) }}</td>
                  <td>{{ fmtInt(c.clientes_unicos) }}</td>
                  <td class="ct-money">{{ fmtMoney(c.count > 0 ? c.monto / c.count : 0) }}</td>
                </tr>
                <tr *ngIf="recaudacion.por_concepto.length === 0">
                  <td colspan="6" class="ct-empty-row">Sin recaudación en este rango</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Top 20 clientes -->
        <div class="ct-card ct-no-padding" *ngIf="recaudacion.top_clientes && recaudacion.top_clientes.length > 0">
          <div class="ct-analisis-toolbar">Top {{ recaudacion.top_clientes.length }} clientes que más pagaron</div>
          <div class="ct-table-wrap">
            <table class="ct-table">
              <thead><tr><th>#</th><th>Cliente</th><th>Cédula</th><th>Pagos</th><th>Total pagado</th></tr></thead>
              <tbody>
                <tr *ngFor="let c of recaudacion.top_clientes; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ c.full_name || '—' }} <span class="ct-cliente-code">{{ c.code }}</span></td>
                  <td>{{ c.identity || '—' }}</td>
                  <td>{{ fmtInt(c.count) }}</td>
                  <td class="ct-money">{{ fmtMoney(c.monto) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Serie diaria -->
        <div class="ct-card ct-no-padding" *ngIf="recaudacion.serie_diaria && recaudacion.serie_diaria.length > 0">
          <div class="ct-analisis-toolbar">Serie diaria de recaudación ({{ recaudacion.serie_diaria.length }} días)</div>
          <div class="ct-table-wrap" style="max-height:400px; overflow-y:auto;">
            <table class="ct-table">
              <thead><tr><th>Fecha</th><th>Pagos</th><th>Monto</th></tr></thead>
              <tbody>
                <tr *ngFor="let d of recaudacion.serie_diaria">
                  <td>{{ fmtDate(d.fecha) }}</td>
                  <td>{{ fmtInt(d.count) }}</td>
                  <td class="ct-money">{{ fmtMoney(d.monto) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- ─── Próximos a C004 ─── -->
    <ng-container *ngIf="operacionTab === 'proximos_c004'">
      <div class="ct-analisis-desc">
        <strong>Cobranza preventiva</strong> — clientes con mora entre <strong>{{ proximosRangoMin }} y {{ proximosRangoMax }} días</strong>,
        a punto de cruzar al rango C004 (61+) donde se les genera fee de reactivación. Prioriza llamadas/comunicación AHORA.
      </div>

      <div class="ct-filter-row" style="margin-bottom: 12px;">
        <div class="ct-filter-grp">
          <label>Rango mora</label>
          <input type="number" [(ngModel)]="proximosRangoMin" class="ct-input ct-input-num">
          <span>–</span>
          <input type="number" [(ngModel)]="proximosRangoMax" class="ct-input ct-input-num">
          <button class="ct-btn-primary ct-btn-mini" (click)="reloadProximosC004()">Aplicar</button>
        </div>
      </div>

      <div *ngIf="loadingProx" class="ct-empty"><span class="ct-spinner-sm"></span> Calculando candidatos…</div>

      <div *ngIf="proximosC004 && !loadingProx">
        <div class="ct-card ct-no-padding">
          <div class="ct-analisis-toolbar">
            <strong>{{ proximosC004.total }}</strong> clientes en rango {{ proximosC004.rango.min }}-{{ proximosC004.rango.max }} días
          </div>
          <div class="ct-table-wrap" *ngIf="proximosC004.clientes.length > 0">
            <table class="ct-table">
              <thead>
                <tr>
                  <th>Cliente</th><th>Cédula</th><th>Mora actual</th><th>Días para C004</th><th>$ Adeudado</th><th>Reactivaciones</th><th>Próxima cuota</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of proximosC004.clientes">
                  <td>{{ c.full_name || '—' }} <span class="ct-cliente-code">{{ c.code }}</span></td>
                  <td>{{ c.identity || '—' }}</td>
                  <td><span class="ct-mora-badge mora-med">{{ c.mora_actual }}d</span></td>
                  <td><strong [class.ct-urgent]="c.dias_para_c004 <= 3">{{ c.dias_para_c004 }}d</strong></td>
                  <td class="ct-money">{{ fmtMoney(c.monto) }}</td>
                  <td class="ct-center">
                    <span *ngIf="c.penalty_count > 0" class="ct-reactivation-pill">{{ c.penalty_count }}×</span>
                    <span *ngIf="!c.penalty_count" class="ct-muted">—</span>
                  </td>
                  <td>
                    <span *ngIf="c.proxima_cuota">{{ fmtDate(c.proxima_cuota.scheduledPaymentDate) }} · {{ fmtMoney(c.proxima_cuota.amount) }}</span>
                    <span *ngIf="!c.proxima_cuota" class="ct-muted">—</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="proximosC004.clientes.length === 0" class="ct-empty">
            No hay clientes en ese rango de mora actualmente
          </div>
        </div>
      </div>
    </ng-container>

    <!-- ─── Aging contable ─── -->
    <ng-container *ngIf="operacionTab === 'aging'">
      <div class="ct-analisis-desc">
        <strong>Aging clásico contable</strong> — distribución de cartera por antigüedad de mora.
        Bucket "Al día" = clientes activos sin mora; "Castigo" / "Pérdida" = posibles candidatos a write-off.
      </div>

      <div *ngIf="loadingAging" class="ct-empty"><span class="ct-spinner-sm"></span> Calculando aging…</div>

      <div *ngIf="aging && !loadingAging">
        <div class="ct-kpis">
          <div class="ct-kpi">
            <div class="ct-kpi-label">Total clientes (con mora calculada)</div>
            <div class="ct-kpi-value">{{ fmtInt(aging.total_clientes) }}</div>
          </div>
          <div class="ct-kpi ct-kpi-accent">
            <div class="ct-kpi-label">Monto total adeudado</div>
            <div class="ct-kpi-value">{{ fmtMoney(aging.total_monto) }}</div>
          </div>
        </div>

        <div class="ct-card ct-no-padding">
          <div class="ct-analisis-toolbar">Distribución por bucket</div>
          <div class="ct-table-wrap">
            <table class="ct-table">
              <thead>
                <tr>
                  <th>Bucket</th><th>Clientes</th><th>%</th><th>Monto pendiente</th><th>% Monto</th><th>Fees C001</th><th>Monto C001</th><th>Fees C004</th><th>Monto C004</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let b of aging.buckets">
                  <td><strong>{{ b.rango }}</strong></td>
                  <td>{{ fmtInt(b.clientes) }}</td>
                  <td>{{ b.pct_clientes }}%</td>
                  <td class="ct-money">{{ fmtMoney(b.monto_pendiente) }}</td>
                  <td>{{ b.pct_monto }}%</td>
                  <td>{{ fmtInt(b.fees_c001) }}</td>
                  <td>{{ fmtMoney(b.fees_c001_monto) }}</td>
                  <td>{{ fmtInt(b.fees_c004) }}</td>
                  <td>{{ fmtMoney(b.fees_c004_monto) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ng-container>
  </section>

  <!-- ─── TAB: MOROSIDAD (NPL profesional - Basel/IFRS9) ─────────── -->
  <section *ngIf="activeTab === 'morosidad'" class="ct-tab-panel">
    <div class="ct-anom-banner" style="display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap;">
      <span style="flex:1;min-width:200px;">Indicadores ejecutivos de cartera · GLP / NPL / PAR / Aging configurable · Estándar Basel III / NIIF 9</span>
      <span class="ct-cache-stamp" *ngIf="morosidadUpdatedAt">
        <span *ngIf="refreshingMorosidad" class="ct-spinner-tiny"></span>
        {{ refreshingMorosidad ? 'Actualizando…' : fmtCacheTimestamp(morosidadUpdatedAt) }}
      </span>
      <button class="ct-btn-ghost ct-btn-mini" (click)="openConfigDrawer()">⚙️ Configurar indicadores</button>
    </div>

    <!-- ═══ Distribución del dinero en la calle (Metabase) ═══ -->
    <div class="card mb-3">
      <div class="card-header d-flex align-items-center justify-content-between bg-light">
        <h6 class="mb-0">
          <i class="bi bi-cash-stack me-2"></i>
          Distribución del dinero en la calle
        </h6>
        <small class="text-muted">Alineado con Metabase · Suma = GLP</small>
      </div>
      <div class="card-body p-0">
        <ng-container *ngIf="distribucionDineroLoading">
          <div class="p-3 text-muted small">
            <span class="spinner-border spinner-border-sm me-2"></span>
            Calculando distribución...
          </div>
        </ng-container>
        <ng-container *ngIf="distribucionDineroError">
          <div class="p-3 text-danger small">
            ⚠️ {{ distribucionDineroError }}
          </div>
        </ng-container>
        <table class="table table-sm mb-0" *ngIf="distribucionDinero && !distribucionDineroLoading">
          <thead class="table-light">
            <tr>
              <th>Grupo</th>
              <th class="text-end">Cuotas</th>
              <th class="text-end">Monto pendiente (USD)</th>
              <th class="text-end">Personas</th>
              <th class="text-end" style="width:80px">% GLP</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let g of distribucionDinero.grupos">
              <td>
                <span class="badge me-2" [style.background-color]="g.color" style="width:12px; height:12px; padding:0; display:inline-block; border-radius:2px;"></span>
                <strong>{{ g.label }}</strong>
              </td>
              <td class="text-end">{{ g.count_cuotas | number }}</td>
              <td class="text-end fw-semibold">$ {{ g.monto_pendiente | number:'1.2-2' }}</td>
              <td class="text-end">{{ g.count_personas | number }}</td>
              <td class="text-end text-muted">
                {{ distribucionDinero.totales.monto_pendiente > 0
                    ? ((g.monto_pendiente / distribucionDinero.totales.monto_pendiente * 100) | number:'1.1-1')
                    : '0.0' }}%
              </td>
            </tr>
          </tbody>
          <tfoot class="table-light fw-bold">
            <tr>
              <td>TOTAL (GLP)</td>
              <td class="text-end">{{ distribucionDinero.totales.count_cuotas | number }}</td>
              <td class="text-end">$ {{ distribucionDinero.totales.monto_pendiente | number:'1.2-2' }}</td>
              <td class="text-end">—</td>
              <td class="text-end">100.0%</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <!-- ═══ /Distribución del dinero ═══ -->

    <!-- Loading global SOLO si no hay datos cacheados -->
    <div *ngIf="loadingMorosidad && !morosidadData" class="ct-empty"><span class="ct-spinner-sm"></span> Calculando indicadores…</div>

    <ng-container *ngIf="morosidadData">
      <!-- GLP (Gross Loan Portfolio) -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">Cartera Bruta (GLP - Gross Loan Portfolio)</div>
        <div class="ct-anom-grid ct-anom-grid-4">
          <div class="ct-anom-card">
            <div class="ct-anom-card-label">GLP Total</div>
            <div class="ct-anom-card-value">{{ fmtMoney(morosidadData.glp?.total) }}</div>
            <div class="ct-anom-card-hint">{{ fmtInt(morosidadData.glp?.count_cuotas) }} cuotas vivas</div>
          </div>
          <div class="ct-anom-card" style="border-left:4px solid #22c55e;">
            <div class="ct-anom-card-label">Cartera al día</div>
            <div class="ct-anom-card-value">{{ fmtMoney(morosidadData.cartera_al_dia?.monto) }}</div>
            <div class="ct-anom-card-hint">{{ morosidadData.cartera_al_dia?.ratio_glp_pct }}% del GLP</div>
          </div>
          <div class="ct-anom-card" style="border-left:4px solid #f59e0b;">
            <div class="ct-anom-card-label">Cartera en mora</div>
            <div class="ct-anom-card-value">{{ fmtMoney(morosidadData.cartera_en_mora?.monto) }}</div>
            <div class="ct-anom-card-hint">{{ fmtInt(morosidadData.cartera_en_mora?.count) }} cuotas · {{ morosidadData.cartera_en_mora?.ratio_glp_pct }}% del GLP</div>
          </div>
          <div class="ct-anom-card" style="border-left:4px solid #b91c1c;">
            <div class="ct-anom-card-label">NPL ratio (real)</div>
            <div class="ct-anom-card-value">{{ morosidadData.npl?.ratio_glp_pct }}%</div>
            <div class="ct-anom-card-hint">{{ fmtMoney(morosidadData.npl?.monto) }} sobre GLP</div>
          </div>
        </div>
      </div>

      <!-- 5 vistas de morosidad — auditadas -->
      <div class="ct-anom-section" *ngIf="morosidadData.morosidad_comparativa?.metricas?.length">
        <div class="ct-anom-section-label">
          📊 % Morosidad — 5 vistas comparativas (cada una mide algo distinto, todas correctas)
        </div>
        <div class="ct-anom-grid ct-anom-grid-5">
          <div class="ct-anom-card ct-clickable" *ngFor="let m of morosidadData.morosidad_comparativa.metricas"
               [style.border-left]="'4px solid ' + m.color"
               (click)="openMetricaDetail(m)"
               title="Click para ver fórmula y detalles">
            <div class="ct-anom-card-label">{{ m.id }} · {{ m.tipo }}</div>
            <div class="ct-anom-card-value" [style.color]="m.color">{{ m.valor_pct }}%</div>
            <div class="ct-anom-card-hint" style="font-size:10px;line-height:1.3;">{{ m.nombre }}</div>
            <div style="margin-top:6px;font-size:10px;color:#3b82f6;">ℹ️ Ver fórmula →</div>
          </div>
        </div>
        <div class="ct-card" style="margin-top:12px;padding:10px 14px;background:#f8fafc;">
          <table class="ct-table" style="font-size:11px;">
            <thead>
              <tr><th>#</th><th>Métrica</th><th class="ct-num">Valor</th><th>Interpretación</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let m of morosidadData.morosidad_comparativa.metricas">
                <td><strong [style.color]="m.color">{{ m.id }}</strong></td>
                <td>{{ m.nombre }}</td>
                <td class="ct-num"><strong>{{ m.valor_pct }}%</strong></td>
                <td><em style="color:#64748b;font-size:10px;">{{ m.interpretacion }}</em></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Charts row: Aging + NPL Gauge -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">Distribución gráfica</div>
        <div class="ct-charts-grid">
          <div class="ct-card cd-chart-card" style="flex:2;min-width:0;">
            <h3 style="margin-top:0;">Aging buckets ($ por bucket)</h3>
            <div class="cd-chart-canvas" style="height:280px;">
              <canvas #agingChart></canvas>
            </div>
          </div>
          <div class="ct-card cd-chart-card" style="flex:1;min-width:0;">
            <h3 style="margin-top:0;">NPL Ratio sobre GLP</h3>
            <div style="position:relative;height:280px;display:flex;flex-direction:column;align-items:center;justify-content:center;">
              <canvas #nplGaugeChart></canvas>
              <div style="position:absolute;top:55%;left:50%;transform:translate(-50%,-50%);text-align:center;">
                <div style="font-size:36px;font-weight:700;color:#0f172a;">{{ morosidadData.npl?.ratio_glp_pct }}%</div>
                <div style="font-size:11px;color:#64748b;text-transform:uppercase;letter-spacing:0.5px;">NPL Ratio</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- PAR (Portfolio at Risk) thresholds -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">PAR · Portfolio at Risk (cartera con riesgo DPD > X)</div>
        <div class="ct-anom-grid ct-anom-grid-4">
          <div class="ct-anom-card ct-anom-card-soft" *ngFor="let key of ['par30','par60','par90','par180']">
            <div class="ct-anom-card-label">PAR{{ key.replace('par','') }}</div>
            <div class="ct-anom-card-value">{{ morosidadData.par?.[key]?.ratio_monto_pct }}%</div>
            <div class="ct-anom-card-money">{{ fmtMoney(morosidadData.par?.[key]?.monto) }}</div>
            <div class="ct-anom-card-hint">{{ fmtInt(morosidadData.par?.[key]?.count) }} clientes</div>
          </div>
        </div>
      </div>

      <!-- KPIs secundarios -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">Composición de riesgo</div>
        <div class="ct-anom-grid ct-anom-grid-4">
          <div class="ct-anom-card">
            <div class="ct-anom-card-label">NPL count (#)</div>
            <div class="ct-anom-card-value">{{ fmtInt(morosidadData.npl?.count) }}</div>
            <div class="ct-anom-card-hint">{{ morosidadData.npl?.ratio_count_pct }}% del total</div>
          </div>
          <div class="ct-anom-card">
            <div class="ct-anom-card-label">NPL Formation</div>
            <div class="ct-anom-card-value">{{ fmtInt(morosidadData.npl_formation?.count) }}</div>
            <div class="ct-anom-card-hint">{{ fmtMoney(morosidadData.npl_formation?.monto) }} · {{ morosidadData.npl_formation?.window }} (nuevos NPL)</div>
          </div>
          <div class="ct-anom-card">
            <div class="ct-anom-card-label">Concentración Top 10</div>
            <div class="ct-anom-card-value">{{ morosidadData.concentracion?.top10_pct_npl }}%</div>
            <div class="ct-anom-card-hint">{{ fmtMoney(morosidadData.concentracion?.top10_monto) }} del NPL total</div>
          </div>
          <div class="ct-anom-card">
            <div class="ct-anom-card-label">Cure rate</div>
            <div class="ct-anom-card-value">{{ morosidadData.cure_rate?.available ? morosidadData.cure_rate?.direction : '—' }}</div>
            <div class="ct-anom-card-hint">{{ morosidadData.cure_rate?.available ? ('Δ al día: ' + (morosidadData.cure_rate?.delta_al_dia || 0)) : (morosidadData.cure_rate?.reason || 'Esperando snapshots') }}</div>
          </div>
        </div>
      </div>

      <!-- Bucket Aging -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">Bucket aging (distribución por días de mora)</div>
        <div class="ct-card ct-no-padding">
          <table class="ct-table">
            <thead>
              <tr>
                <th>Bucket</th>
                <th>Rango</th>
                <th class="ct-num">Clientes</th>
                <th class="ct-num">% del total</th>
                <th class="ct-num">Monto</th>
                <th class="ct-num">% del monto</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let b of morosidadData.aging" [class.ct-row-highlight]="b.bucket >= 91">
                <td><strong>{{ b.label }}</strong></td>
                <td>{{ b.range }}</td>
                <td class="ct-num">{{ fmtInt(b.count) }}</td>
                <td class="ct-num">{{ morosidadData.cartera?.count > 0 ? ((b.count / morosidadData.cartera.count) * 100).toFixed(2) : 0 }}%</td>
                <td class="ct-num">{{ fmtMoney(b.monto) }}</td>
                <td class="ct-num">{{ morosidadData.cartera?.monto > 0 ? ((b.monto / morosidadData.cartera.monto) * 100).toFixed(2) : 0 }}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Distribución NPL -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">Composición del NPL (&gt;90d)</div>
        <div class="ct-anom-grid ct-anom-grid-4">
          <div class="ct-anom-card ct-anom-card-soft" *ngFor="let d of morosidadData.npl_distribution">
            <div class="ct-anom-card-label">{{ d.range }}</div>
            <div class="ct-anom-card-value">{{ fmtInt(d.count) }}</div>
            <div class="ct-anom-card-money">{{ fmtMoney(d.monto) }}</div>
          </div>
        </div>
      </div>

      <!-- Top 20 Deudores NPL -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">Top 20 deudores NPL · mayor exposición</div>
        <div class="ct-card ct-no-padding">
          <table class="ct-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Cliente</th>
                <th>Cédula</th>
                <th class="ct-num">Días mora</th>
                <th class="ct-num">Cuotas</th>
                <th class="ct-num">Exposición</th>
                <th class="ct-num">Activo</th>
                <th class="ct-num">Reactiv.</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of morosidadData.top_deudores_npl; let i = index">
                <td>{{ i + 1 }}</td>
                <td><a [routerLink]="['/console/cliente', d.code]" target="_blank">{{ d.full_name || '(sin nombre)' }}</a></td>
                <td>{{ d.identity || '-' }}</td>
                <td class="ct-num"><span [ngClass]="{'ct-text-danger': d.dias_mora > 180}">{{ d.dias_mora }}d</span></td>
                <td class="ct-num">{{ d.cuotas_en_mora }}</td>
                <td class="ct-num"><strong>{{ fmtMoney(d.monto) }}</strong></td>
                <td class="ct-num">{{ d.quota_active ? '✅' : '🔒' }}</td>
                <td class="ct-num">{{ d.reactivaciones }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Roll Rate Matrix -->
      <div class="ct-anom-section" *ngIf="morosidadData.roll_rate_matrix">
        <div class="ct-anom-section-label">Roll rate matrix · estado actual por bucket vs reactivación</div>
        <div class="ct-card ct-no-padding">
          <table class="ct-table">
            <thead>
              <tr>
                <th>Bucket</th>
                <th class="ct-num">Sin reactivación</th>
                <th class="ct-num">Con reactivación</th>
                <th class="ct-num">Total</th>
                <th class="ct-num">% reactivados</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let b of morosidadData.roll_rate_matrix.buckets" [class.ct-row-highlight]="b === '>180d'">
                <td><strong>{{ b }}</strong></td>
                <td class="ct-num">{{ fmtInt(morosidadData.roll_rate_matrix.sin_reactivacion[b]) }}</td>
                <td class="ct-num">{{ fmtInt(morosidadData.roll_rate_matrix.con_reactivacion[b]) }}</td>
                <td class="ct-num"><strong>{{ fmtInt(morosidadData.roll_rate_matrix.totales[b]) }}</strong></td>
                <td class="ct-num">
                  {{ morosidadData.roll_rate_matrix.totales[b] > 0
                    ? ((morosidadData.roll_rate_matrix.con_reactivacion[b] / morosidadData.roll_rate_matrix.totales[b]) * 100).toFixed(2)
                    : 0 }}%
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="ct-text-muted ct-text-small" style="margin-top:6px;">
          Snapshot del estado actual por bucket. Una matriz de transición real (bucket N → N+1 mes a mes) requiere acumular snapshots históricos.
        </div>
      </div>

      <!-- Cure Rate -->
      <div class="ct-anom-section" *ngIf="morosidadData.cure_rate?.total_reactivados > 0">
        <div class="ct-anom-section-label">Cure Rate · clientes reactivados (Ajuste 17)</div>
        <div class="ct-anom-grid ct-anom-grid-4">
          <div class="ct-anom-card">
            <div class="ct-anom-card-label">Total reactivados (lifetime)</div>
            <div class="ct-anom-card-value">{{ fmtInt(morosidadData.cure_rate?.total_reactivados) }}</div>
            <div class="ct-anom-card-hint">Pagaron C004 al menos una vez</div>
          </div>
          <div class="ct-anom-card" style="border-left:4px solid #22c55e;">
            <div class="ct-anom-card-label">Cure rate (al día)</div>
            <div class="ct-anom-card-value">{{ morosidadData.cure_rate?.cure_rate_pct }}%</div>
            <div class="ct-anom-card-hint">{{ fmtInt(morosidadData.cure_rate?.curados) }} curados</div>
          </div>
          <div class="ct-anom-card" style="border-left:4px solid #f59e0b;">
            <div class="ct-anom-card-label">Re-default rate</div>
            <div class="ct-anom-card-value">{{ morosidadData.cure_rate?.re_default_pct }}%</div>
            <div class="ct-anom-card-hint">{{ fmtInt(morosidadData.cure_rate?.recayeron) }} recayeron en mora</div>
          </div>
          <div class="ct-anom-card" style="border-left:4px solid #b91c1c;">
            <div class="ct-anom-card-label">Críticos &gt;60d</div>
            <div class="ct-anom-card-value">{{ fmtInt(morosidadData.cure_rate?.criticos_60) }}</div>
            <div class="ct-anom-card-hint">Reactivados en mora avanzada otra vez</div>
          </div>
        </div>
      </div>

      <!-- Vintage Cohorts -->
      <div class="ct-anom-section" *ngIf="morosidadData.vintage_cohorts?.length > 0">
        <div class="ct-anom-section-label">Vintage cohorts · % deterioro por mes de originación (últimos 24 meses)</div>

        <div class="ct-card cd-chart-card" style="margin-bottom:16px;">
          <div class="cd-chart-canvas" style="height:300px;">
            <canvas #vintageChart></canvas>
          </div>
        </div>

        <div class="ct-card ct-no-padding">
          <table class="ct-table">
            <thead>
              <tr>
                <th>Mes originación</th>
                <th class="ct-num">Créditos</th>
                <th class="ct-num">Mora actual %</th>
                <th class="ct-num">Mora &gt;30d %</th>
                <th class="ct-num">Mora &gt;60d %</th>
                <th class="ct-num">Mora &gt;90d %</th>
                <th class="ct-num">Mora &gt;180d %</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of morosidadData.vintage_cohorts">
                <td><strong>{{ c.cohort }}</strong></td>
                <td class="ct-num">{{ fmtInt(c.total_creditos) }}</td>
                <td class="ct-num">{{ c.mora_actual_pct }}%</td>
                <td class="ct-num"><span [ngClass]="{'ct-text-danger': c.mora_30_pct > 5}">{{ c.mora_30_pct }}%</span></td>
                <td class="ct-num"><span [ngClass]="{'ct-text-danger': c.mora_60_pct > 5}">{{ c.mora_60_pct }}%</span></td>
                <td class="ct-num"><span [ngClass]="{'ct-text-danger': c.mora_90_pct > 5}">{{ c.mora_90_pct }}%</span></td>
                <td class="ct-num"><span [ngClass]="{'ct-text-danger': c.mora_180_pct > 3}">{{ c.mora_180_pct }}%</span></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="ct-text-muted ct-text-small" style="margin-top:6px;">
          Cohortes recientes con 0% en >30d/>90d son normales (los créditos aún no han madurado). Un % alto en cohorte vieja indica deterioro de calidad de underwriting en ese mes.
        </div>
      </div>

      <div class="ct-text-muted ct-text-small" style="text-align:right;margin-top:8px;">
        Computado en {{ morosidadData.elapsed_ms }} ms · {{ morosidadData.snapshots_disponibles || 0 }} snapshots almacenados
      </div>
    </ng-container>
  </section>

  <!-- ─── TAB: COMPORTAMIENTO DE PAGO EN TIEMPO ─────────────────────────────────── -->
  <section *ngIf="activeTab === 'comportamiento'" class="ct-tab-panel">
    <div class="ct-anom-banner" style="display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap;">
      <span style="flex:1;min-width:200px;">Métricas de comportamiento de pago. Series temporales basadas en snapshots diarios (02:00 Caracas).</span>
      <span class="ct-cache-stamp" *ngIf="comportamientoUpdatedAt">
        <span *ngIf="refreshingComportamiento" class="ct-spinner-tiny"></span>
        {{ refreshingComportamiento ? 'Actualizando…' : fmtCacheTimestamp(comportamientoUpdatedAt) }}
      </span>
      <button class="ct-btn-ghost ct-btn-mini" (click)="triggerSnapshotNow()" [disabled]="loadingComportamiento">📸 Snapshot ahora</button>
    </div>

    <div *ngIf="loadingComportamiento && !comportamientoData" class="ct-empty"><span class="ct-spinner-sm"></span> Calculando comportamiento…</div>

    <ng-container *ngIf="comportamientoData">
      <ng-container *ngIf="comportamientoData.latest_snapshot as latest">

        <!-- KPIs día actual -->
        <div class="ct-anom-section">
          <div class="ct-anom-section-label">Snapshot del día · {{ fmtDate(latest.date) }}</div>
          <div class="ct-anom-grid ct-anom-grid-4">
            <div class="ct-anom-card">
              <div class="ct-anom-card-label">DPD promedio</div>
              <div class="ct-anom-card-value">{{ latest.dpd?.avg | number:'1.0-0' }}d</div>
              <div class="ct-anom-card-hint">Mediana {{ latest.dpd?.median }}d · Máx {{ latest.dpd?.max }}d</div>
            </div>
            <div class="ct-anom-card">
              <div class="ct-anom-card-label">% Pagos a tiempo</div>
              <div class="ct-anom-card-value">{{ latest.recaudacion?.on_time_pct }}%</div>
              <div class="ct-anom-card-hint">{{ fmtInt(latest.recaudacion?.pagos_a_tiempo) }} de {{ fmtInt(latest.recaudacion?.count) }} pagos del día</div>
            </div>
            <div class="ct-anom-card">
              <div class="ct-anom-card-label">First Payment Default</div>
              <div class="ct-anom-card-value"><span [ngClass]="{'ct-text-danger': latest.fpd?.fpd_pct > 5}">{{ latest.fpd?.fpd_pct }}%</span></div>
              <div class="ct-anom-card-hint">{{ fmtInt(latest.fpd?.fpd_count) }} de {{ fmtInt(latest.fpd?.creditos_nuevos_count) }} créditos nuevos (>5% = red flag)</div>
            </div>
            <div class="ct-anom-card">
              <div class="ct-anom-card-label">Recaudación del día</div>
              <div class="ct-anom-card-value">{{ fmtMoney(latest.recaudacion?.monto) }}</div>
              <div class="ct-anom-card-hint">{{ fmtInt(latest.recaudacion?.count) }} cuotas pagadas</div>
            </div>
          </div>
        </div>

        <!-- Fees del día -->
        <div class="ct-anom-section">
          <div class="ct-anom-section-label">Fees C001 / C004</div>
          <div class="ct-anom-grid ct-anom-grid-4">
            <div class="ct-anom-card ct-anom-card-soft">
              <div class="ct-anom-card-label">C001 pendientes</div>
              <div class="ct-anom-card-value">{{ fmtInt(latest.fees?.c001_pendientes_count) }}</div>
              <div class="ct-anom-card-money">{{ fmtMoney(latest.fees?.c001_pendientes_monto) }}</div>
            </div>
            <div class="ct-anom-card ct-anom-card-soft">
              <div class="ct-anom-card-label">C001 cobrados hoy</div>
              <div class="ct-anom-card-value">{{ fmtInt(latest.fees?.c001_pagados_dia_count) }}</div>
              <div class="ct-anom-card-money">{{ fmtMoney(latest.fees?.c001_pagados_dia_monto) }}</div>
            </div>
            <div class="ct-anom-card ct-anom-card-soft">
              <div class="ct-anom-card-label">C004 pendientes</div>
              <div class="ct-anom-card-value">{{ fmtInt(latest.fees?.c004_pendientes_count) }}</div>
              <div class="ct-anom-card-money">{{ fmtMoney(latest.fees?.c004_pendientes_monto) }}</div>
            </div>
            <div class="ct-anom-card ct-anom-card-soft">
              <div class="ct-anom-card-label">CEI (Collection Eff. Index)</div>
              <div class="ct-anom-card-value">{{ latest.cei_pct }}%</div>
              <div class="ct-anom-card-hint">Pagado del día / cobrable</div>
            </div>
          </div>
        </div>

        <!-- Roll rates -->
        <div class="ct-anom-section" *ngIf="comportamientoData.roll_rates?.available">
          <div class="ct-anom-section-label">Roll rates · {{ fmtDate(comportamientoData.roll_rates.dates.ayer) }} → {{ fmtDate(comportamientoData.roll_rates.dates.hoy) }}</div>
          <div class="ct-card ct-no-padding">
            <table class="ct-table">
              <thead>
                <tr><th>Desde</th><th>Hacia</th><th class="ct-num">Tasa</th></tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of comportamientoData.roll_rates.roll_rates">
                  <td>{{ r.from }}</td><td>{{ r.to }}</td>
                  <td class="ct-num"><span [ngClass]="{'ct-text-danger': r.rate_pct > 30}">{{ r.rate_pct }}%</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="ct-anom-section" *ngIf="!comportamientoData.roll_rates?.available">
          <div class="ct-anom-banner">
            ℹ️ Roll rates disponibles cuando haya al menos 2 snapshots (necesita el cron diario corriendo). Snapshots actuales: {{ comportamientoData.n_snapshots }}.
          </div>
        </div>

        <!-- Series temporales (tabla simple por ahora; charts cuando haya 7+ snapshots) -->
        <div class="ct-anom-section" *ngIf="comportamientoData.n_snapshots >= 2">
          <div class="ct-anom-section-label">Serie histórica · últimos {{ comportamientoData.period_days }} días ({{ comportamientoData.n_snapshots }} snapshots)</div>
          <div class="ct-card ct-no-padding">
            <table class="ct-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th class="ct-num">DPD avg</th>
                  <th class="ct-num">CEI %</th>
                  <th class="ct-num">On-time %</th>
                  <th class="ct-num"># pagos</th>
                  <th class="ct-num">$ recaudado</th>
                  <th class="ct-num">FPD %</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let s of comportamientoData.dpd_series; let i = index">
                  <td>{{ fmtDate(s.date) }}</td>
                  <td class="ct-num">{{ s.avg | number:'1.0-1' }}</td>
                  <td class="ct-num">{{ comportamientoData.cei_series[i]?.cei_pct }}%</td>
                  <td class="ct-num">{{ comportamientoData.on_time_series[i]?.on_time_pct }}%</td>
                  <td class="ct-num">{{ fmtInt(comportamientoData.recaudacion_series[i]?.count) }}</td>
                  <td class="ct-num">{{ fmtMoney(comportamientoData.recaudacion_series[i]?.monto) }}</td>
                  <td class="ct-num">{{ comportamientoData.fpd_series[i]?.fpd_pct }}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </ng-container>

      <div class="ct-text-muted ct-text-small" style="text-align:right;margin-top:8px;">
        Computado en {{ comportamientoData.elapsed_ms }} ms · {{ comportamientoData.n_snapshots }} snapshots almacenados
      </div>
    </ng-container>
  </section>

  <!-- ─── TAB: GESTIÓN DE COBRO (Excel V16) ─────────────────────── -->
  <section *ngIf="activeTab === 'gestion-cobro'" class="ct-tab-panel">
    <div class="ct-anom-banner" style="display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap;">
      <span style="flex:1;min-width:200px;">💰 Gestión de cobro replica del Excel V16: cobranza mensual por cohorte · Recovery · Por vencer · Histórico diario · Target {{ gestionCobroData?.target_pct || 96 }}%</span>
      <span class="ct-cache-stamp" *ngIf="gestionCobroUpdatedAt">
        <span *ngIf="refreshingGestionCobro" class="ct-spinner-tiny"></span>
        {{ refreshingGestionCobro ? 'Actualizando…' : fmtCacheTimestamp(gestionCobroUpdatedAt) }}
      </span>
    </div>

    <div *ngIf="loadingGestionCobro && !gestionCobroData" class="ct-empty"><span class="ct-spinner-sm"></span> Computando gestión de cobro (puede tardar 30-60s)…</div>

    <ng-container *ngIf="gestionCobroData">
      <!-- Recovery lifetime -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">Recovery Lifetime · ¿llegamos al {{ gestionCobroData.target_pct }}%?</div>
        <div class="ct-anom-grid ct-anom-grid-4">
          <div class="ct-anom-card">
            <div class="ct-anom-card-label">Total financiado</div>
            <div class="ct-anom-card-value">{{ fmtMoney(gestionCobroData.recovery?.lifetime?.monto_total) }}</div>
            <div class="ct-anom-card-hint">{{ fmtInt(gestionCobroData.recovery?.lifetime?.cuotas_total) }} cuotas lifetime</div>
          </div>
          <div class="ct-anom-card" style="border-left:4px solid #22c55e;">
            <div class="ct-anom-card-label">Total cobrado</div>
            <div class="ct-anom-card-value">{{ fmtMoney(gestionCobroData.recovery?.lifetime?.monto_cobrado) }}</div>
            <div class="ct-anom-card-hint">{{ fmtInt(gestionCobroData.recovery?.lifetime?.cuotas_cobradas) }} cuotas conciliadas</div>
          </div>
          <div class="ct-anom-card">
            <div class="ct-anom-card-label">Recovery %</div>
            <div class="ct-anom-card-value">{{ gestionCobroData.recovery?.lifetime?.recovery_monto_pct }}%</div>
            <div class="ct-anom-card-hint">Cuotas: {{ gestionCobroData.recovery?.lifetime?.recovery_cuotas_pct }}%</div>
          </div>
          <div class="ct-anom-card" [style.border-left]="gestionCobroData.recovery?.lifetime?.faltan_96_pct > 0 ? '4px solid #ef4444' : '4px solid #22c55e'">
            <div class="ct-anom-card-label">Faltan para {{ gestionCobroData.target_pct }}%</div>
            <div class="ct-anom-card-value">{{ gestionCobroData.recovery?.lifetime?.faltan_96_pct }}%</div>
            <div class="ct-anom-card-hint">{{ fmtMoney(gestionCobroData.recovery?.lifetime?.faltan_96_monto) }} faltan cobrar</div>
          </div>
        </div>
      </div>

      <!-- Por año -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">Recovery por año</div>
        <div class="ct-card ct-no-padding">
          <table class="ct-table">
            <thead>
              <tr>
                <th>Año</th>
                <th class="ct-num">Cuotas</th>
                <th class="ct-num">Financiado</th>
                <th class="ct-num">Cobradas</th>
                <th class="ct-num">Cobrado</th>
                <th class="ct-num">Recovery %</th>
                <th class="ct-num">Faltan {{ gestionCobroData.target_pct }}%</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let a of gestionCobroData.recovery?.por_anio">
                <td><strong>{{ a.year }}</strong></td>
                <td class="ct-num">{{ fmtInt(a.cuotas_total) }}</td>
                <td class="ct-num">{{ fmtMoney(a.monto_total) }}</td>
                <td class="ct-num">{{ fmtInt(a.cuotas_cobradas) }}</td>
                <td class="ct-num">{{ fmtMoney(a.monto_cobrado) }}</td>
                <td class="ct-num"><span [ngClass]="{'ct-text-danger': a.recovery_monto_pct < gestionCobroData.target_pct}">{{ a.recovery_monto_pct }}%</span></td>
                <td class="ct-num">{{ fmtMoney(a.faltan_96_monto) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Por Vencer -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">Por Vencer (cuotas futuras no vencidas)</div>
        <div class="ct-anom-grid ct-anom-grid-4">
          <div class="ct-anom-card">
            <div class="ct-anom-card-label">Total por vencer</div>
            <div class="ct-anom-card-value">{{ fmtInt(gestionCobroData.por_vencer?.por_vencer?.total?.count) }}</div>
            <div class="ct-anom-card-money">{{ fmtMoney(gestionCobroData.por_vencer?.por_vencer?.total?.monto) }}</div>
          </div>
          <div class="ct-anom-card ct-anom-card-soft">
            <div class="ct-anom-card-label">Próximos 7 días</div>
            <div class="ct-anom-card-value">{{ fmtInt(gestionCobroData.por_vencer?.por_vencer?.next_7d?.count) }}</div>
            <div class="ct-anom-card-money">{{ fmtMoney(gestionCobroData.por_vencer?.por_vencer?.next_7d?.monto) }}</div>
          </div>
          <div class="ct-anom-card ct-anom-card-soft">
            <div class="ct-anom-card-label">Próximos 30 días</div>
            <div class="ct-anom-card-value">{{ fmtInt(gestionCobroData.por_vencer?.por_vencer?.next_30d?.count) }}</div>
            <div class="ct-anom-card-money">{{ fmtMoney(gestionCobroData.por_vencer?.por_vencer?.next_30d?.monto) }}</div>
          </div>
          <div class="ct-anom-card ct-anom-card-soft">
            <div class="ct-anom-card-label">Próximos 60 días</div>
            <div class="ct-anom-card-value">{{ fmtInt(gestionCobroData.por_vencer?.por_vencer?.next_60d?.count) }}</div>
            <div class="ct-anom-card-money">{{ fmtMoney(gestionCobroData.por_vencer?.por_vencer?.next_60d?.monto) }}</div>
          </div>
        </div>
      </div>

      <!-- Cartera viva últimos 3 meses -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">Cartera viva · últimos 3 meses</div>
        <div class="ct-anom-grid ct-anom-grid-3">
          <div class="ct-anom-card">
            <div class="ct-anom-card-label">Total financiado 3m</div>
            <div class="ct-anom-card-value">{{ fmtMoney(gestionCobroData.por_vencer?.cartera_viva_3m?.monto_total) }}</div>
            <div class="ct-anom-card-hint">{{ fmtInt(gestionCobroData.por_vencer?.cartera_viva_3m?.cuotas_total) }} cuotas</div>
          </div>
          <div class="ct-anom-card" style="border-left:4px solid #22c55e;">
            <div class="ct-anom-card-label">Ya cobrado</div>
            <div class="ct-anom-card-value">{{ fmtMoney(gestionCobroData.por_vencer?.cartera_viva_3m?.monto_pagado) }}</div>
            <div class="ct-anom-card-hint">Recovery 3m: {{ gestionCobroData.por_vencer?.cartera_viva_3m?.recovery_pct }}%</div>
          </div>
          <div class="ct-anom-card" style="border-left:4px solid #f59e0b;">
            <div class="ct-anom-card-label">Pendiente</div>
            <div class="ct-anom-card-value">{{ fmtMoney(gestionCobroData.por_vencer?.cartera_viva_3m?.monto_pendiente) }}</div>
            <div class="ct-anom-card-hint">{{ fmtInt(gestionCobroData.por_vencer?.cartera_viva_3m?.cuotas_pendientes) }} cuotas pendientes</div>
          </div>
        </div>
      </div>

      <!-- Cobranza mensual por cohorte -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">Cobranza mensual por cohorte de originación · {{ fmtInt(gestionCobroData.cobranza_mensual?.cohorts?.length) }} meses</div>
        <div class="ct-card ct-no-padding" style="max-height:500px;overflow-y:auto;">
          <table class="ct-table">
            <thead style="position:sticky;top:0;background:white;">
              <tr>
                <th>Mes</th>
                <th class="ct-num">Cuotas</th>
                <th class="ct-num">Financiado</th>
                <th class="ct-num">Conciliadas</th>
                <th class="ct-num">Conciliado</th>
                <th class="ct-num">Pendientes</th>
                <th class="ct-num">Pendiente</th>
                <th class="ct-num">Progreso</th>
                <th class="ct-num">Faltan {{ gestionCobroData.target_pct }}%</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of gestionCobroData.cobranza_mensual?.cohorts"
                  [style.background]="c.progreso_monto_pct >= gestionCobroData.target_pct ? '#f0fdf4' : c.progreso_monto_pct >= 80 ? '#fffbeb' : '#fef2f2'">
                <td><strong>{{ c.month_label }}</strong></td>
                <td class="ct-num">{{ fmtInt(c.cuotas_total) }}</td>
                <td class="ct-num">{{ fmtMoney(c.monto_total) }}</td>
                <td class="ct-num">{{ fmtInt(c.cuotas_conciliadas) }}</td>
                <td class="ct-num">{{ fmtMoney(c.monto_conciliado) }}</td>
                <td class="ct-num">{{ fmtInt(c.cuotas_pendientes) }}</td>
                <td class="ct-num">{{ fmtMoney(c.monto_pendiente) }}</td>
                <td class="ct-num"><strong>{{ c.progreso_monto_pct }}%</strong></td>
                <td class="ct-num">
                  <span [ngClass]="{'ct-text-danger': c.faltan_96_pct > 0}">
                    {{ c.faltan_96_pct }}% ({{ fmtMoney(c.faltan_96_monto) }})
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="ct-text-muted ct-text-small" style="text-align:right;margin-top:8px;">
        Computado en {{ gestionCobroData.elapsed_ms }} ms · Target Recovery: {{ gestionCobroData.target_pct }}% · Target Morosidad máx: {{ gestionCobroData.target_morosidad_pct }}%
      </div>
    </ng-container>
  </section>

  <!-- ─── TAB: ANOMALÍAS ─────────────────────────────────── -->
  <section *ngIf="activeTab === 'anomalias'" class="ct-tab-panel">
    <div class="ct-anom-banner">
      Auditoría de integridad del sistema. Click en una card para ver detalle y descargar Excel.
    </div>

    <div *ngIf="loadingAnomaliasResumen" class="ct-empty"><span class="ct-spinner-sm"></span> Analizando anomalías…</div>

    <ng-container *ngIf="anomaliasResumen && !anomaliaTipo">
      <!-- Sección 1: Fees C001 (foco operativo) -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">Fees C001 con problemas</div>
        <div class="ct-anom-grid ct-anom-grid-3">
          <div class="ct-anom-card" (click)="openAnomaliaList('cuotas-fee-jamas')">
            <div class="ct-anom-card-label">Sin fee creado</div>
            <div class="ct-anom-card-value">{{ fmtInt(anomaliasResumen.cuotas_fee?.jamas?.count || 0) }}</div>
            <div class="ct-anom-card-money">{{ fmtMoney(anomaliasResumen.cuotas_fee?.jamas?.monto || 0) }}</div>
            <div class="ct-anom-card-hint">Nunca tuvieron fee C001</div>
          </div>
          <div class="ct-anom-card" (click)="openAnomaliaList('cuotas-fee-regenerar')">
            <div class="ct-anom-card-label">Fee a regenerar</div>
            <div class="ct-anom-card-value">{{ fmtInt(anomaliasResumen.cuotas_fee?.regenerar_paid?.count || 0) }}</div>
            <div class="ct-anom-card-money">{{ fmtMoney(anomaliasResumen.cuotas_fee?.regenerar_paid?.monto || 0) }}</div>
            <div class="ct-anom-card-hint">Fee viejo pagado, cuota sigue en mora</div>
          </div>
          <div class="ct-anom-card" (click)="openAnomaliaList('cuotas-fee-desactualizado')">
            <div class="ct-anom-card-label">Fee desactualizado</div>
            <div class="ct-anom-card-value">{{ fmtInt(anomaliasResumen.cuotas_fee?.desactualizado?.count || 0) }}</div>
            <div class="ct-anom-card-money">{{ fmtMoney(anomaliasResumen.cuotas_fee?.desactualizado?.monto || 0) }}</div>
            <div class="ct-anom-card-hint">Días del fee ≠ debtor_days actual</div>
          </div>
        </div>
      </div>

      <!-- Sección 2: Estado del sistema -->
      <div class="ct-anom-section">
        <div class="ct-anom-section-label">Estado del sistema</div>
        <div class="ct-anom-grid ct-anom-grid-4">
          <div class="ct-anom-card ct-anom-card-soft" (click)="openAnomaliaList('sin-recalc')">
            <div class="ct-anom-card-label">Sin recálculo hoy</div>
            <div class="ct-anom-card-value">{{ fmtInt(anomaliasResumen.sin_recalc_hoy) }}</div>
            <div class="ct-anom-card-hint">Cron no los actualizó</div>
          </div>
          <div class="ct-anom-card ct-anom-card-soft" (click)="openAnomaliaList('mora-incoherente')">
            <div class="ct-anom-card-label">Mora incoherente</div>
            <div class="ct-anom-card-value">{{ fmtInt(anomaliasResumen.mora_incoherente) }}</div>
            <div class="ct-anom-card-hint">count vs actual vs monto</div>
          </div>
          <div class="ct-anom-card ct-anom-card-soft" (click)="openAnomaliaList('bloqueados-sin-mora')">
            <div class="ct-anom-card-label">Bloqueados sin mora</div>
            <div class="ct-anom-card-value">{{ fmtInt(anomaliasResumen.bloqueados_sin_mora) }}</div>
            <div class="ct-anom-card-hint">Posibles casos tipo Luzbey</div>
          </div>
          <div class="ct-anom-card ct-anom-card-soft" (click)="openAnomaliaList('criticos-180')">
            <div class="ct-anom-card-label">Críticos &gt;180d</div>
            <div class="ct-anom-card-value">{{ fmtInt(anomaliasResumen.criticos_180.count) }}</div>
            <div class="ct-anom-card-money">{{ fmtMoney(anomaliasResumen.criticos_180.monto) }}</div>
            <div class="ct-anom-card-hint">Write-off candidates</div>
          </div>
        </div>
      </div>

      <button class="ct-anom-help-toggle" (click)="showAnomHelp = !showAnomHelp">
        {{ showAnomHelp ? '▼' : '▶' }} ¿Qué significa cada anomalía?
      </button>
      <div class="ct-card" *ngIf="showAnomHelp">
        <table class="ct-table">
          <tbody>
            <tr><td><strong>Sin recálculo hoy</strong></td><td>Cron nocturno no actualizó al cliente</td></tr>
            <tr><td><strong>Sin fee creado</strong></td><td>Cuota en mora que nunca tuvo fee C001 (ni PAID ni deleted)</td></tr>
            <tr><td><strong>Fee a regenerar</strong></td><td>Tiene fee C001 PAID viejo, cuota sigue en mora con saldo — el cron debe crear un fee nuevo</td></tr>
            <tr><td><strong>Fee desactualizado</strong></td><td>Tiene fee C001 PEND pero `days` del fee no coincide con el `debtor_days` actual (típico $3→$4 al pasar 45/60d)</td></tr>
            <tr><td><strong>Mora incoherente</strong></td><td>Person.mora con datos contradictorios (count vs actual vs monto)</td></tr>
            <tr><td><strong>Bloqueados con mora=0</strong></td><td>Auto-bloqueado pero mora ya es 0 (caso tipo Luzbey)</td></tr>
            <tr><td><strong>Críticos &gt;180d</strong></td><td>Candidatos a write-off / castigo contable</td></tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!-- Lista detallada de una anomalía -->
    <ng-container *ngIf="anomaliaTipo">
      <div class="ct-card ct-no-padding">
        <div class="ct-analisis-toolbar" style="display:flex;justify-content:space-between;align-items:center;">
          <div>
            <strong>{{ anomaliaTitle }}</strong> · {{ fmtInt(anomaliaTotal) }} resultados
          </div>
          <div style="display:flex;gap:8px;">
            <button class="ct-btn-primary ct-btn-mini" (click)="downloadAnomaliaXlsx()">📥 Descargar XLSX</button>
            <button class="ct-btn-ghost ct-btn-mini" (click)="closeAnomaliaList()">← Volver</button>
          </div>
        </div>

        <div *ngIf="loadingAnomaliaList" class="ct-empty"><span class="ct-spinner-sm"></span> Cargando…</div>

        <div class="ct-table-wrap" *ngIf="!loadingAnomaliaList && anomaliaItems.length > 0">
          <table class="ct-table">
            <thead>
              <tr><th *ngFor="let c of anomaliaColumns()">{{ c }}</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of anomaliaItems">
                <td *ngFor="let c of anomaliaColumns()">{{ formatAnomaliaCell(row[c]) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="!loadingAnomaliaList && anomaliaItems.length === 0" class="ct-empty">
          Sin resultados
        </div>
      </div>
    </ng-container>
  </section>

  <!-- ─── DRAWER DETALLE CLIENTE ────────────────────────── -->
  <div class="ct-drawer-backdrop" *ngIf="drawerOpen" (click)="closeDrawer()"></div>
  <aside class="ct-drawer" *ngIf="drawerOpen">
    <header class="ct-drawer-header">
      <div>
        <h2 *ngIf="selectedCliente">{{ selectedCliente.full_name || selectedCliente.code }}</h2>
        <h2 *ngIf="!selectedCliente">Cargando…</h2>
        <div class="ct-drawer-sub" *ngIf="selectedCliente">
          <span>{{ selectedCliente.identity || '—' }}</span>
          <span class="ct-dot-sep">·</span>
          <span class="ct-mono">{{ selectedCliente.code }}</span>
        </div>
      </div>
      <button class="ct-btn-close" (click)="closeDrawer()">✕</button>
    </header>

    <div class="ct-drawer-body" *ngIf="!drawerLoading && selectedCliente">
      <!-- Acciones rápidas -->
      <section class="ct-d-actions">
        <button class="ct-btn-action" (click)="recalcCliente()" [disabled]="actionLoading === 'recalc'">
          <span *ngIf="actionLoading !== 'recalc'">↻</span>
          <span *ngIf="actionLoading === 'recalc'" class="ct-spinner-sm"></span>
          Recalcular mora
        </button>
        <button class="ct-btn-action" [class.ct-btn-danger]="selectedCliente.quota_active" [class.ct-btn-success]="!selectedCliente.quota_active"
                (click)="toggleBloqueo()" [disabled]="actionLoading === 'bloqueo'">
          <span *ngIf="actionLoading !== 'bloqueo'">{{ selectedCliente.quota_active ? '🔒' : '🔓' }}</span>
          <span *ngIf="actionLoading === 'bloqueo'" class="ct-spinner-sm"></span>
          {{ selectedCliente.quota_active ? 'Bloquear' : 'Desbloquear' }}
        </button>
        <button class="ct-btn-action" (click)="verPerfilCompleto()">
          ↗ Ver perfil completo
        </button>
      </section>
      <div *ngIf="actionMessage" class="ct-action-message">{{ actionMessage }}</div>

      <!-- Estado -->
      <section class="ct-d-section">
        <h4>Estado</h4>
        <div class="ct-flag-grid">
          <div class="ct-flag" [class.on]="selectedCliente.quota_active" [class.off]="!selectedCliente.quota_active">
            <span class="ct-flag-label">Quota</span>
            <span class="ct-flag-value">{{ selectedCliente.quota_active ? 'Activo' : 'Bloqueado' }}</span>
          </div>
          <div class="ct-flag" [class.on]="!selectedCliente.user_blocked_manually" [class.off]="selectedCliente.user_blocked_manually">
            <span class="ct-flag-label">Bloqueo manual</span>
            <span class="ct-flag-value">{{ selectedCliente.user_blocked_manually ? 'Sí' : 'No' }}</span>
          </div>
          <div class="ct-flag" [class.on]="!selectedCliente.reactivation_blocked" [class.off]="selectedCliente.reactivation_blocked">
            <span class="ct-flag-label">React. bloqueada</span>
            <span class="ct-flag-value">{{ selectedCliente.reactivation_blocked ? selectedCliente.reactivation_block_reason || 'Sí' : 'No' }}</span>
          </div>
        </div>
      </section>

      <!-- Mora -->
      <section class="ct-d-section">
        <h4>Mora</h4>
        <div class="ct-stat-grid">
          <div><span>Mora actual</span><strong>{{ selectedCliente.mora?.actual || 0 }}d</strong></div>
          <div><span>Cuotas en mora</span><strong>{{ selectedCliente.mora?.actual_count || 0 }}</strong></div>
          <div><span>$ Adeudado</span><strong>{{ fmtMoney(selectedCliente.mora?.actual_monto_pendiente) }}</strong></div>
          <div><span>Mora histórica</span><strong>{{ selectedCliente.mora?.max_historica || 0 }}d</strong></div>
          <div><span>Effective</span><strong>{{ selectedCliente.mora?.effective ?? '—' }}</strong></div>
          <div><span>Cuotas a tiempo</span><strong>{{ selectedCliente.mora?.cuotas_a_tiempo || 0 }}</strong></div>
          <div><span>Cuotas tarde</span><strong>{{ selectedCliente.mora?.cuotas_tarde || 0 }}</strong></div>
          <div><span>Promedio retraso</span><strong>{{ selectedCliente.mora?.dias_promedio_retraso || 0 }}d</strong></div>
        </div>
        <div class="ct-recalc">Recalculado: {{ fmtRelative(selectedCliente.last_mora_recalculated_at) }}</div>
      </section>

      <!-- Reactivaciones -->
      <section class="ct-d-section" *ngIf="selectedCliente.penalty_reactivation_count > 0 || selectedCliente.penalty_reactivation_history.length > 0">
        <h4>Reactivaciones C004</h4>
        <div class="ct-react-count">
          Total pagos C004: <strong>{{ selectedCliente.penalty_reactivation_count }}</strong>
        </div>
        <ul class="ct-timeline" *ngIf="selectedCliente.penalty_reactivation_history.length > 0">
          <li *ngFor="let r of selectedCliente.penalty_reactivation_history">
            <span class="ct-tl-date">{{ fmtDate(r.payment_date) }}</span>
            <span class="ct-tl-data">{{ r.fee_code || 'C004' }} · {{ fmtMoney(r.amount) }} · max: {{ r.max_mora_at_reactivation || '—' }}d</span>
          </li>
        </ul>
      </section>

      <!-- Fees pendientes -->
      <section class="ct-d-section" *ngIf="selectedCliente.fees_pendientes.length > 0">
        <h4>Fees pendientes ({{ selectedCliente.fees_pendientes.length }})</h4>
        <table class="ct-mini-table">
          <thead><tr><th>Concepto</th><th>Días</th><th>Monto</th><th>Pendiente</th><th>Fecha</th></tr></thead>
          <tbody>
            <tr *ngFor="let f of selectedCliente.fees_pendientes">
              <td><span class="ct-fee-tag">{{ f.concept_code || '—' }}</span></td>
              <td>{{ f.days || '—' }}d</td>
              <td>{{ fmtMoney(f.amount) }}</td>
              <td>{{ fmtMoney(f.due_balance) }}</td>
              <td>{{ fmtDate(f.date) }}</td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- Cuotas en mora (con fee asociado) -->
      <section class="ct-d-section" *ngIf="selectedCliente.cuotas_en_mora.length > 0">
        <h4>Cuotas en mora ({{ selectedCliente.cuotas_en_mora.length }})</h4>
        <div class="ct-cuotas-list">
          <div class="ct-cuota-card" *ngFor="let q of selectedCliente.cuotas_en_mora">
            <div class="ct-cuota-head">
              <div>
                <strong>Cuota #{{ q.order }}</strong>
                <span style="color:#64748b">· Crédito {{ q.invoice_identifier || '#' + q.invoice_number }}</span>
              </div>
              <span class="ct-mora-badge" [ngClass]="moraBadge(q.debtor_days_count)">{{ q.debtor_days_count }}d</span>
            </div>
            <div class="ct-cuota-meta">
              Vencía: <strong>{{ fmtDate(q.scheduledPaymentDate) }}</strong>
              · Monto: <strong>{{ fmtMoney(q.amount) }}</strong>
              · Pendiente: <strong style="color:#dc2626">{{ fmtMoney(q.dueBalance) }}</strong>
              <span *ngIf="q.amount && q.dueBalance && q.dueBalance < q.amount" class="ct-fee-pill" style="background:#fef3c7;color:#92400e;">pago parcial</span>
              <span *ngIf="q.amount && q.dueBalance >= q.amount" style="color:#64748b">(sin pago parcial)</span>
            </div>
            <!-- Fee asociado -->
            <div class="ct-cuota-fee" *ngIf="q.fee_status" [style.borderLeftColor]="q.fee_status.color || '#cbd5e1'">
              <span class="ct-fee-pill" [style.background]="q.fee_status.color ? q.fee_status.color + '22' : '#f1f5f9'" [style.color]="q.fee_status.color || '#475569'">
                💰 {{ q.fee_status.label }}
              </span>
              <span *ngIf="q.fee_status.fee" style="font-size:11px;color:#64748b;margin-left:8px">
                Fee {{ q.fee_status.fee.concept_code }} · {{ fmtMoney(q.fee_status.fee.amount) }}
                <span *ngIf="q.fee_status.fee.due_balance > 0">· pend {{ fmtMoney(q.fee_status.fee.due_balance) }}</span>
                · días al cobrar: {{ q.fee_status.fee.days }}
                <span *ngIf="q.fee_status.fee.last_update_date">· {{ fmtDate(q.fee_status.fee.last_update_date) }}</span>
              </span>
            </div>
          </div>
        </div>
      </section>

      <!-- Cuotas pagadas recientes (con fee asociado) -->
      <section class="ct-d-section" *ngIf="selectedCliente.cuotas_pagadas_recientes && selectedCliente.cuotas_pagadas_recientes.length > 0">
        <h4>Cuotas pagadas recientes ({{ selectedCliente.cuotas_pagadas_recientes.length }})</h4>
        <div class="ct-cuotas-list">
          <div class="ct-cuota-card" *ngFor="let q of selectedCliente.cuotas_pagadas_recientes.slice(0, 10)">
            <div class="ct-cuota-head">
              <div>
                <strong>Cuota #{{ q.order }}</strong>
                <span style="color:#64748b">· Crédito #{{ q.invoice_number }}</span>
              </div>
              <span class="ct-fee-pill" [style.background]="q.dias_retraso > 0 ? '#fee2e2' : '#dcfce7'" [style.color]="q.dias_retraso > 0 ? '#dc2626' : '#16a34a'">
                {{ q.dias_retraso > 0 ? q.dias_retraso + 'd tarde' : 'a tiempo' }}
              </span>
            </div>
            <div class="ct-cuota-meta">
              Vencía: <strong>{{ fmtDate(q.scheduledPaymentDate) }}</strong>
              · Pagó: <strong>{{ fmtDate(q.payment_date) }}</strong>
              · Monto: <strong>{{ fmtMoney(q.amount) }}</strong>
            </div>
            <div class="ct-cuota-fee" *ngIf="q.fee_status" [style.borderLeftColor]="q.fee_status.color || '#cbd5e1'">
              <span class="ct-fee-pill" [style.background]="q.fee_status.color ? q.fee_status.color + '22' : '#f1f5f9'" [style.color]="q.fee_status.color || '#475569'">
                💰 {{ q.fee_status.label }}
              </span>
              <span *ngIf="q.fee_status.fee" style="font-size:11px;color:#64748b;margin-left:8px">
                Fee {{ q.fee_status.fee.concept_code }} · {{ fmtMoney(q.fee_status.fee.amount) }}
                · días al cobrar: {{ q.fee_status.fee.days }}
              </span>
            </div>
          </div>
        </div>
      </section>

      <!-- Próxima cuota -->
      <section class="ct-d-section" *ngIf="selectedCliente.mora?.proxima_cuota">
        <h4>Próxima cuota a vencer</h4>
        <div class="ct-stat-grid">
          <div><span>Orden</span><strong>{{ selectedCliente.mora.proxima_cuota.order }}</strong></div>
          <div><span>Crédito</span><strong>#{{ selectedCliente.mora.proxima_cuota.invoice_number }}</strong></div>
          <div><span>Fecha</span><strong>{{ fmtDate(selectedCliente.mora.proxima_cuota.scheduledPaymentDate) }}</strong></div>
          <div><span>Monto</span><strong>{{ fmtMoney(selectedCliente.mora.proxima_cuota.amount) }}</strong></div>
        </div>
      </section>

      <!-- Pagos recientes -->
      <section class="ct-d-section" *ngIf="selectedCliente.fees_pagados_recientes.length > 0">
        <h4>Pagos recientes ({{ selectedCliente.fees_pagados_recientes.length }})</h4>
        <table class="ct-mini-table">
          <thead><tr><th>Concepto</th><th>Días</th><th>Monto</th><th>Fecha</th></tr></thead>
          <tbody>
            <tr *ngFor="let p of selectedCliente.fees_pagados_recientes">
              <td><span class="ct-fee-tag">{{ p.concept_code || '—' }}</span></td>
              <td>{{ p.days || '—' }}d</td>
              <td>{{ fmtMoney(p.amount) }}</td>
              <td>{{ fmtDate(p.date) }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>

    <div class="ct-drawer-loading" *ngIf="drawerLoading">
      <div class="ct-spinner"></div>
      <span>Cargando detalle...</span>
    </div>
  </aside>

  <!-- ─── DRAWER: Detalle de métrica F1-F5 ─────────────────────── -->
  <div class="ct-cfg-overlay" *ngIf="selectedMetrica" (click)="closeMetricaDetail()"></div>
  <aside class="ct-cfg-drawer" *ngIf="selectedMetrica">
    <div class="ct-cfg-header" [style.background]="selectedMetrica.color + '11'">
      <div>
        <div style="font-size:11px;color:#94a3b8;text-transform:uppercase;letter-spacing:0.5px;">Métrica {{ selectedMetrica.id }} · {{ selectedMetrica.tipo }}</div>
        <h3 style="margin:4px 0 0 0;">{{ selectedMetrica.detalle?.titulo || selectedMetrica.nombre }}</h3>
      </div>
      <button class="ct-btn-ghost ct-btn-mini" (click)="closeMetricaDetail()">✕</button>
    </div>

    <div class="ct-cfg-body">
      <!-- Valor actual -->
      <div style="text-align:center;padding:20px;background:#f8fafc;border-radius:8px;margin-bottom:20px;">
        <div style="font-size:48px;font-weight:700;line-height:1;" [style.color]="selectedMetrica.color">
          {{ selectedMetrica.valor_pct }}%
        </div>
        <div style="font-size:12px;color:#64748b;margin-top:8px;">Valor actual</div>
      </div>

      <!-- Fórmula -->
      <div class="ct-cfg-field">
        <label>📐 Fórmula</label>
        <div style="background:#1e293b;color:#e2e8f0;padding:12px 16px;border-radius:6px;font-family:'Courier New',monospace;font-size:12px;line-height:1.6;">
          {{ selectedMetrica.detalle?.formula }}
        </div>
      </div>

      <!-- Cálculo con datos reales -->
      <div class="ct-cfg-field">
        <label>🧮 Cálculo con datos actuales</label>
        <div style="background:#f0f9ff;border-left:3px solid #3b82f6;padding:10px 14px;border-radius:4px;font-family:'Courier New',monospace;font-size:13px;color:#0f172a;">
          {{ selectedMetrica.detalle?.ejemplo }}
        </div>
      </div>

      <!-- Numerador / Denominador -->
      <div class="ct-cfg-field" *ngIf="selectedMetrica.numerador != null">
        <label>📊 Datos crudos</label>
        <table style="width:100%;font-size:13px;">
          <tr><td style="padding:6px 0;color:#64748b;">Numerador:</td><td style="text-align:right;font-weight:600;">{{ fmtInt(selectedMetrica.numerador) }}</td></tr>
          <tr><td style="padding:6px 0;color:#64748b;">Denominador:</td><td style="text-align:right;font-weight:600;">{{ fmtInt(selectedMetrica.denominador) }}</td></tr>
        </table>
      </div>

      <!-- Fuente de los datos -->
      <div class="ct-cfg-field">
        <label>💾 Fuente de los datos</label>
        <div style="font-size:12px;color:#475569;background:#f8fafc;padding:8px 12px;border-radius:4px;">
          {{ selectedMetrica.detalle?.fuente }}
        </div>
      </div>

      <!-- Cuándo usarla -->
      <div class="ct-cfg-field">
        <label style="color:#16a34a;">✅ Cuándo usarla</label>
        <div style="font-size:13px;color:#0f172a;line-height:1.5;">
          {{ selectedMetrica.detalle?.cuando_usar }}
        </div>
      </div>

      <!-- Cuándo NO usar -->
      <div class="ct-cfg-field">
        <label style="color:#dc2626;">❌ Cuándo NO usar</label>
        <div style="font-size:13px;color:#0f172a;line-height:1.5;">
          {{ selectedMetrica.detalle?.cuando_NO_usar }}
        </div>
      </div>

      <!-- Advertencia -->
      <div class="ct-cfg-field" *ngIf="selectedMetrica.detalle?.advertencia">
        <label style="color:#f59e0b;">⚠️ Advertencia</label>
        <div style="font-size:13px;color:#0f172a;line-height:1.5;background:#fffbeb;border-left:3px solid #f59e0b;padding:8px 12px;border-radius:4px;">
          {{ selectedMetrica.detalle?.advertencia }}
        </div>
      </div>
    </div>

    <div class="ct-cfg-footer">
      <div style="flex:1;font-size:11px;color:#94a3b8;">{{ selectedMetrica.interpretacion }}</div>
      <button class="ct-btn-primary ct-btn-mini" (click)="closeMetricaDetail()">Entendido</button>
    </div>
  </aside>

  <!-- ─── DRAWER: Configuración de indicadores ─────────────────────── -->
  <div class="ct-cfg-overlay" *ngIf="showConfigDrawer" (click)="closeConfigDrawer()"></div>
  <aside class="ct-cfg-drawer" *ngIf="showConfigDrawer && configEditing">
    <div class="ct-cfg-header">
      <h3 style="margin:0;">⚙️ Configuración de indicadores</h3>
      <button class="ct-btn-ghost ct-btn-mini" (click)="closeConfigDrawer()">✕ Cerrar</button>
    </div>

    <div class="ct-cfg-body">
      <!-- NPL Threshold -->
      <div class="ct-cfg-field">
        <label>NPL Threshold (días)</label>
        <input type="number" min="7" max="730" [(ngModel)]="configEditing.npl.threshold_days" (change)="previewConfig()">
        <small class="ct-text-muted">Estándar Basel/IFRS9: 90d. Usar 60d para microcrédito agresivo, 180d para write-off rule.</small>
      </div>

      <!-- Period -->
      <div class="ct-cfg-field">
        <label>Período de análisis (días)</label>
        <input type="number" min="7" max="730" [(ngModel)]="configEditing.period_days" (change)="previewConfig()">
      </div>

      <!-- Top deudores limit -->
      <div class="ct-cfg-field">
        <label>Top deudores · cuántos mostrar</label>
        <input type="number" min="5" max="200" [(ngModel)]="configEditing.top_deudores_limit" (change)="previewConfig()">
      </div>

      <!-- PAR Thresholds -->
      <div class="ct-cfg-field">
        <label>PAR thresholds (separados por coma)</label>
        <input type="text" [value]="configEditing.par_thresholds?.join(',')"
               (change)="onParThresholdsChange($any($event.target).value)">
        <small class="ct-text-muted">Default 30,60,90,180. Cada uno calcula PAR{{ '{' }}n{{ '}' }} = Portfolio at Risk &gt; n días.</small>
      </div>

      <!-- Targets (metas de gestión) -->
      <div class="ct-cfg-field" *ngIf="configEditing.targets">
        <label>🎯 Metas de gestión</label>
        <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;">
          <div>
            <small style="display:block;color:#64748b;font-size:11px;">Recovery target %</small>
            <input type="number" min="0" max="100" step="0.1" [(ngModel)]="configEditing.targets.recovery_pct" (change)="previewConfig()">
            <small class="ct-text-muted" style="font-size:10px;">% mín. de cobranza (Excel V16: 96)</small>
          </div>
          <div>
            <small style="display:block;color:#64748b;font-size:11px;">Morosidad máx %</small>
            <input type="number" min="0" max="100" step="0.1" [(ngModel)]="configEditing.targets.morosidad_pct" (change)="previewConfig()">
            <small class="ct-text-muted" style="font-size:10px;">% máx aceptable en mora (default 5)</small>
          </div>
          <div>
            <small style="display:block;color:#64748b;font-size:11px;">NPL ratio máx %</small>
            <input type="number" min="0" max="100" step="0.1" [(ngModel)]="configEditing.targets.npl_ratio_pct" (change)="previewConfig()">
            <small class="ct-text-muted" style="font-size:10px;">% máx NPL sobre GLP (default 10)</small>
          </div>
        </div>
      </div>

      <!-- Aging buckets editables -->
      <div class="ct-cfg-field">
        <label>Aging buckets</label>
        <div class="ct-cfg-buckets">
          <div class="ct-cfg-bucket-row" *ngFor="let b of configEditing.aging_buckets; let i = index">
            <input type="text" class="ct-cfg-input-sm" [(ngModel)]="b.id" placeholder="id" (change)="previewConfig()">
            <input type="text" class="ct-cfg-input-md" [(ngModel)]="b.label" placeholder="Label" (change)="previewConfig()">
            <input type="number" class="ct-cfg-input-sm" [(ngModel)]="b.min" placeholder="min" (change)="previewConfig()">
            <input type="number" class="ct-cfg-input-sm" [ngModel]="b.max" (ngModelChange)="b.max = $event === null || $event === '' ? null : +$event; previewConfig()" placeholder="max (vacío=∞)">
            <input type="color" class="ct-cfg-input-color" [(ngModel)]="b.color">
            <button class="ct-btn-ghost ct-btn-mini" (click)="removeConfigBucket(i)" [disabled]="configEditing.aging_buckets.length <= 2" title="Eliminar bucket">🗑️</button>
          </div>
        </div>
        <button class="ct-btn-ghost ct-btn-mini" (click)="addConfigBucket()" style="margin-top:8px;">+ Agregar bucket</button>
        <small class="ct-text-muted" style="display:block;margin-top:4px;">
          Los rangos deben ser contiguos: max del bucket N = min del bucket N+1 - 1. Último bucket max = vacío (∞).
        </small>
      </div>

      <!-- Validation error -->
      <div *ngIf="configValidationError" class="ct-cfg-error">
        ⚠️ {{ configValidationError }}
      </div>
    </div>

    <div class="ct-cfg-footer">
      <button class="ct-btn-ghost ct-btn-mini" (click)="restoreDefaults()">↺ Restaurar defaults</button>
      <div style="flex:1;"></div>
      <button class="ct-btn-ghost ct-btn-mini" (click)="closeConfigDrawer()">Cancelar</button>
      <button class="ct-btn-primary ct-btn-mini" (click)="saveConfigGlobal()" [disabled]="configSaving || !!configValidationError">
        {{ configSaving ? 'Guardando…' : '💾 Guardar global' }}
      </button>
    </div>
  </aside>
</div>
